<template>
  <div :class="allEyesModel ? 'taskControl_eyeshield' : 'taskControl'" style="width: 100%; height: 100%;display:flex">
    <div id="svg-container"></div>
    <!-- 用于插入 SVG 的容器 -->
    <div ref="mapRef" id="map-container" style="width: 100%; height: 100%"></div>
    <div class="videoWrap" :style="{ display: isShowVideo ? 'block' : 'none' }">
      <div style="position: relative;width: 100%;height: 100%" :style="{ display: isShowVideo ? 'block' : 'none' }">
        <div class="videoClose" @click="closeVideo">X</div>
        <div class="videoName">{{ videoName }}视频</div>
        <video id="video" ref="video" class="video-js vjs-default-skin" controls preload="auto"
          style="width: 99.6%;height: 99.6%"></video>
      </div>
    </div>
    <div :class="isDetailOpen ? 'opLeftRadar' : 'closeLeftRadar'">
      <canvas id="radarChart" width="280" height="280"></canvas>
    </div>
    <div id="overlay" style="display: block;" :style="{ height: !openLeft ? '400px' : 'calc(100% - 90px)' }">
      <featurePanel :allEyesModel="allEyesModel" :infoArr="infoArr" :realTask="realTask" :taskList="taskList"
        :planeWay="planeWay" :showSign="showSign" :openLeft="openLeft" :deleteShowSign="deleteShowSign"
        :planeAllWay="planeAllWay" :deletePlaneAllWay="deletePlaneAllWay" :airSpace="airSpace"
        :daleteAirSpace="daleteAirSpace" :airPort="airPort" :daleteAirPort="daleteAirPort"
        :positionPoint="positionPoint" @handle-openLeft="handleOpenLeft" @messageFromChild="handleChildMessage"
        @messageWeather="handleWeather" @search-item="searchItem"></featurePanel>
    </div>
    <div id="rightOverlay">
      <div id="weather" v-if="showWeather && weatherInfo.province"
        :style="{ right: isDetailOpen ? 'calc(100% + 68px)' : '68px' }">
        <div class="top">
          <div class="address">
            {{
              weatherInfo.city.includes(weatherInfo.province)
                ? ""
                : weatherInfo.province + "省"
            }}{{ weatherInfo.city }}
          </div>
          <div class="date">{{ formatDate(weatherInfo) }}</div>
        </div>
        <div class="content">
          <div class="temperature">
            {{ weatherInfo.temperature }}℃ &nbsp;
            {{ weatherInfo.weather }}
          </div>

          <div class="bottom">
            <span>风力：{{ weatherInfo.windpower }}级</span>
            <span>风向：{{ weatherInfo.winddirection }}</span>
            <span>湿度：{{ weatherInfo.humidity }}</span>
          </div>
        </div>
        <!-- <img class="nextImg" src="../../assets/img/2dmap/next.png" alt="" /> -->
        <img class="weatherImg" src="../../assets/img/2dmap/sunny.png" alt="" v-if="imgCondition.sunny" />
        <img class="weatherImg" src="../../assets/img/2dmap/rain.png" alt="" v-else-if="imgCondition.rain" />
        <img class="weatherImg" src="../../assets/img/2dmap/cloudy.png" alt="" v-else-if="imgCondition.cloudy" />
        <img class="weatherImg" src="../../assets/img/2dmap/yin.png" alt="" v-else-if="imgCondition.yin" />
      </div>
      <div :class="isDetailOpen ? 'changeMapWithOpen' : 'changeMapWithClose'">
        <div class="situationMapBtns">
          <div style="margin-right: 5px;" class="situationBtn" @click="clickRoad()">
            <img :src="require(`../../assets/img/${allEyesModel ? '2dmap_eyes' : '2dmap'}/${clickroad ? 'luwangtu_click' : 'luwangtu'
              }.png`)
              " alt="" />
          </div>
          <div class="situationBtn" @click="clickStar()">
            <img :src="require(`../../assets/img/${allEyesModel ? '2dmap_eyes' : '2dmap'}/${clickstar ? 'weixingtu_click' : 'weixingtu'
              }.png`)
              " alt="" />
          </div>
        </div>
      </div>
      <div class="rightOpenBtns" v-show="isDetailOpen">
        <div class="rightBtn" @click="
          isDetailOpen = false;
        openLeft = false;
        ">
          <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/pop_close_open.png`)"
            alt="" />
        </div>
      </div>
      <div class="rightCloseBtns" v-show="!isDetailOpen">
        <div class="rightBtn" @click="
          isDetailOpen = true;
        openLeft = true;
        ">
          <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/pop_close_open.png`)"
            alt="" />
        </div>
      </div>
      <planDetail :allEyesModel="allEyesModel" :clickPlaneInfo="clickPlaneInfo" :planeDetailData="planeDetailData"
        :isDetailOpen="isDetailOpen" :planeChartData="planeChartData" :changeDetailOpen="changeDetailOpen">
      </planDetail>
    </div>
    <div :class="isDetailOpen ? 'searchContent' : 'searchContentThin'">
      <el-form :model="searchForm" ref="formRef">
        <el-form-item>
          <div class="searchContent1">
            <el-select v-model="searchForm.uasID" placeholder="请输入飞机序列号" filterable clearable @change="handleSearch">
              <el-option v-for="item in uavSerials" :key="item.id" :label="item.uasID" :value="item.id"></el-option>
              <!--              <i slot="prefix" @click="handleSearch" class="el-input__icon el-icon-search"></i>-->
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <!--      <div-->
      <!--        id="radarCanvasWrap" @dblclick="torAdarDerail">-->
      <!--        <canvas id="radarChart" width="280" height="280"></canvas>-->
      <!--      </div>-->
    </div>
    <div id="overlayMeteo" v-if="false">
      <meteorologyPanel :runTask="runTask" :infoArr="infoArr" :preTask="preTask" :realTask="realTask"
        :planeWay="planeWay" :showSign="showSign" :deleteShowSign="deleteShowSign" :planeAllWay="planeAllWay"
        :deletePlaneAllWay="deletePlaneAllWay" :airSpace="airSpace" :daleteAirSpace="daleteAirSpace" :airPort="airPort"
        :daleteAirPort="daleteAirPort" :positionPoint="positionPoint" @messageFromChild="handleChildMessage"
        @changeMeteo="changeMeteo"></meteorologyPanel>
    </div>
    <div v-if="showAirLine">
      <el-container>
        <el-header style="height: 54px !important;">
          <span class="spanSize"> 航线管理</span>
          <el-button size="small" :class="showlineall ? 'showAllBtnActive' : 'showAllBtn'" @click="showAll()">显示全部
          </el-button>
        </el-header>
        <el-main class="main-container">
          <div>
            <el-table height="288px" :data="tableData">
              <el-table-column align="center" prop="name" label="航线名称" min-width="70">
              </el-table-column>
              <el-table-column prop="updatedAt" label="更新时间" min-width="90">
              </el-table-column>
              <el-table-column prop="isShowLine" label="航线" min-width="20">
                <template #default="scope">
                  <el-checkbox @change="
                    v => {
                      handelShowLine(v, scope.row.id);
                    }
                  " v-model="scope.row.isShowLine"></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-main>
      </el-container>
    </div>
    <div v-if="showAirSpace">
      <el-container>
        <el-header style="height: 54px !important;">
          <span class="spanSize"> 空域管理</span>
          <el-button size="small" :class="showAirspaceAll ? 'showAllBtnActive' : 'showAllBtn'"
            @click="showAllAirSpace()">显示全部
          </el-button>
        </el-header>
        <el-main class="main-container">
          <el-table height="288px" :data="airSpaceTableData">
            <el-table-column prop="airspaceName" label="名称" min-width="100">
            </el-table-column>
            <el-table-column prop="TYPE" label="类型" min-width="80">
              <template slot-scope="scope">
                {{ getTypeText(scope.row.TYPE) }}
              </template>
            </el-table-column>
            <el-table-column prop="COLOR" label="颜色" min-width="40">
              <!-- <template slot-scope="scope">
                  <div class="scopeColor" :style="{background:scope.row.COLOR}"></div>
                </template> -->
            </el-table-column>
            <el-table-column prop="STARTTIME" label="开始时间" min-width="90">
            </el-table-column>
            <el-table-column prop="ENDTIME" label="结束时间" min-width="90">
            </el-table-column>
            <el-table-column prop="isShowAirSpace" label="显示" min-width="40">
              <template #default="scope">
                <el-checkbox @change="
                  v => {
                    handelShowAirSpace(v, scope.row.id);
                  }
                " v-model="scope.row.isShowAirSpace"></el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </div>
    <div :class="isDetailOpen ? 'changeWithOpen' : 'changeAirSpace'">
      <!-- 右侧 -->
      <div class="airSpaceBtnOne">
        <div title="空域" class="chooseBtn" :class="airSpaceChecked ? 'active' : ''" @click="
          handelAirSpace
        ">
          <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${airSpaceChecked ? 'kong_yu_click' : 'kong_yu_normal'}.png`)

            " alt="" />
        </div>
        <div title="设备" class="chooseBtn" :class="shibeiChecked ? 'active' : ''" @click="
          shibeiChecked = !shibeiChecked;
        equip = !equip;
        ">
          <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${shibeiChecked ? 'she_bei_click' : 'she_bei_normal'
            }.png`)
            " alt="" />
        </div>
        <div title="航线/点/迹" class="chooseBtn" :class="airPointLineChecked ? 'active' : ''" @click="
          handelairPointLine
        ">
          <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${airPointLineChecked ? 'fei_xing_click' : 'fei_xing_normal'
            }.png`)
            " alt="" />
        </div>
        <div title="工具" class="chooseBtn" :class="toolChecked ? 'active' : ''" @click="toolChecked = !toolChecked">
          <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${toolChecked ? 'gong_ju_click' : 'gong_ju_normal'
            }.png`)
            " alt="" />
        </div>
        <div title="地图要素                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  " class="chooseBtn" :class="airPointLineChecked ? 'active' : ''" @click="
          mapElementsChecked = !mapElementsChecked;
          ">
          <img :src="require(`../../assets/img/${allEyesModel ? '2dmap_eyes' : '2dmap'}/${mapElementsChecked ? 'di_tu_yao_su_click' : 'di_tu_yao_su_normal'
            }.png`)
            " alt="" />
        </div>
      </div>
    </div>
    <div class="levelOneBtns" :style="{ right: isDetailOpen ? '370px' : '12px' }">
      <!--      <div class="airSpaceBtn" style="width: 100%;height: 100%;">-->
      <div title="数据协同" class="chooseBtn" @click="sendData()">
        <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${sendDataChecked
          ? 'shu_ju_xie_tong_click'
          : 'shu_ju_xie_tong_normal'
          }.png`)
          " alt="" />
      </div>
      <div title="气象" class="chooseBtn" @click="callweather()">
        <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${active6 ? 'qi_xiang_click' : 'qi_xiang_normal'
          }.png`)
          " alt="" />
      </div>
      <div title="热力图" class="chooseBtn" @click="
        relituChecked = !relituChecked;
      addHot();
      ">
        <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${relituChecked ? 'ren_kou_mi_du_click' : 'ren_kou_mi_du_normal'
          }.png`)
          " alt="" />
      </div>
    </div>
    <div :class="isDetailOpen ? 'changeWithOpen1' : 'changeAirSpace1'">
      <!-- 右侧 -->
      <div class="airSpaceBtn" style="width: 100%;height: 100%;">
        <div v-show="area" class="area">
          <div class="chooseBtn" :class="showAirSpace ? 'Active' : 'noActive'">
            <div @click="callairSpace()">空域管理</div>
          </div>

          <div class="changeWithOpenXianArea"></div>
        </div>
        <div v-show="equip" class="equip">
          <div class="chooseBtn" :class="showADSB ? 'Active' : 'noActive'">
            <span class="point monitorPoint"> </span>
            <div @click="changeADSBEquipment">ADSB侦察</div>
          </div>
          <div class="chooseBtn" :class="showOneRadar ? 'Active' : 'noActive'">
            <span class="point monitorPoint"> </span>
            <div @click="changeOneRadarEquipment">一次雷达</div>
          </div>
          <div class="chooseBtn" :class="isDisplayCountermeasureEquipment ? 'Active' : 'noActive'">
            <span class="point countermeasuwrePoint"> </span>
            <div @click="changeCountermeasureEquipment">侦测设备</div>
          </div>
          <div class="chooseBtn" :class="isDisplayWeatherEquipment ? 'Active' : 'noActive'">
            <span class="point weatherPoint"> </span>
            <div @click="changeWeatherEquipment">气象设备</div>
          </div>
          <div class="chooseBtn" :class="isDisplayMonitorEquipment ? 'Active' : 'noActive'">
            <span class="point videoPoint"> </span>
            <div @click="changeMonitorEquipment">视频设备</div>
          </div>
          <div class="chooseBtn" :class="isDisplayNavigationEquipment ? 'Active' : 'noActive'">
            <span class="point navigationPoint"> </span>
            <div @click="changeNavigationEquipment">导航设备</div>
          </div>
          <div class="chooseBtn" :class="isDisplayCommunicationEquipment ? 'Active' : 'noActive'">
            <span class="point communicationPoint"> </span>
            <div @click="changeCommunicationEquipment">通信设备</div>
          </div>
          <div class="chooseBtn" :class="active2 ? 'Active' : 'noActive'">
            <div @click="callShowSign">标牌</div>
          </div>
          <div class="chooseBtn" :class="!isSimplifyTooltip ? 'Active' : 'noActive'">
            <div @click="changeTooltipBtn">详细标牌</div>
          </div>
          <div class="changeWithOpenXianEquip"></div>
        </div>
        <div v-show="airPointLine" class="airPointLine">
          <div class="chooseBtn" :class="active1 ? 'Active' : 'noActive'">
            <div @click="callplayWay()">航迹</div>
          </div>
          <div class="chooseBtn" :class="showNormalairPort ? 'Active' : 'noActive'">
            <div @click="debouncedChangeormalAirPot()">航点</div>
          </div>
          <div class="chooseBtn" :class="showairPort ? 'Active' : 'noActive'">
            <div @click="debouncedChangeAirPot()">起降点</div>
          </div>
          <div class="chooseBtn" :class="showDubuleLine ? 'Active' : 'noActive'">
            <div @click="debouncedChangeLine()">切换航线</div>
          </div>
          <div class="chooseBtn" :class="showAirLineName ? 'Active' : 'noActive'">
            <div @click="changeAirLineName">航线名</div>
          </div>
          <div class="chooseBtn" :class="showAirLine ? 'Active' : 'noActive'">
            <div @click="callPlanWay()">航线管理</div>
          </div>
          <div class="changeWithOpenXianAirPointLine"></div>
        </div>
        <div v-show="toolChecked" class="toolbox">
          <div class="chooseBtn" :class="showCircle ? 'Active' : 'noActive'">
            <div @click="
              showCircle = !showCircle;
            addCircles();
            ">
              距离环
            </div>
          </div>
          <div class="chooseBtn" :class="showRange ? 'Active' : 'noActive'">
            <div @click="enablePolylineDrawing()">测距</div>
          </div>
          <div class="changeWithOpenXianToolbox"></div>
        </div>
        <div v-show="mapElementsChecked" class="mapElements">
          <div class="chooseBtn" :class="showRoadNetwork ? 'Active' : 'noActive'">
            <div @click="
              handelShowRoadNetwork
            ">路网
            </div>
          </div>
          <div class="chooseBtn" :class="showGreenPart ? 'Active' : 'noActive'">
            <div @click="
              handelShowGreenPart
            ">绿地
            </div>
          </div>
          <div class="chooseBtn" :class="showRiver ? 'Active' : 'noActive'">
            <div @click="
              handelShowRiver
            ">水系
            </div>
          </div>
          <div class='changeWithOpenMapElements'>

          </div>
        </div>
      </div>
    </div>
    <div :class="isDetailOpen ? 'changeWithOpenBottom' : 'changeAirSpaceBottom'"></div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.heat";
import "leaflet-velocity";
import {
  wgs84ToGcj02,
  gcj02ToWgs84
} from "../../../src/assets/js/map/ConverseLngAndLa";
import featurePanel from "./FeaturePanel";
import meteorologyPanel from "./MeteorologyPanel.vue";
import planDetail from "./PlanDetail.vue";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/leaflet.markercluster.js";
import "leaflet-rotatedmarker";
import { timestampToHss, timestampToTime } from "../../utils/tools";
import Hls from "hls.js";
import _ from "lodash";
import jsonData from "../../assets/js/population.json";
import luwangGeoJson from "../../assets/provinceJson/luwang.geojson";
import greenPartGeoJsont from "../../assets/provinceJson/greenPart.geojson";
import riverGeoJson from "../../assets/provinceJson/river.geojson";

export default {
  name: "TaskControl",
  props: {
    ws: {
      type: WebSocket,
      default: null
    },
    //是否护眼模式
    isStyleApplied: {
      type: Boolean,
      default: true
    },
    //是否是大屏
    isBigScreen: {
      type: Boolean,
      default: false
    },
    //大屏是否显示护眼模式
    isEyeshield: {
      type: Boolean,
      default: true
    },
    //大屏ws
    wsBigScreen: {
      type: WebSocket,
      default: null
    }
  },
  components: {
    featurePanel,
    meteorologyPanel,
    planDetail
  },
  data() {
    return {
      typeMap: {
        1: 30,  // 多旋翼
        2: 45,  // 复合翼
        3: 60,  // ADSB
        4: 30,  // 反制
        5: 60,  // eVTOL
        11: 45, // 车
      },
      typeMarkerSizeMap: {
        1: "planeMarkerImg30",  // 多旋翼
        2: "planeMarkerImg45",  // 复合翼
        3: "planeMarkerImg60",  // ADSB
        4: "planeMarkerImg30",  // 反制
        5: "planeMarkerImg60",  // eVTOL
        11:"planeMarkerImg45", // 车
      },
      roadNetworkObj:null,
      greenPartObj:null,
      riverObj:null,
      showRoadNetwork: false,
      showGreenPart: false,
      showRiver: false,
      mapElementsChecked: false,
      showAirLineName: true,
      sendDataChecked: false, //数据协同按钮
      cityLayer: null,
      relituChecked: false, //选择热力图
      toolChecked: false, //选择工具
      showCircle: false, //距离环
      showRange: false, //测距
      airSpaceChecked: false,
      shibeiChecked: true,
      populationChecked: false,
      airPointLineChecked: false,
      area: false,
      equip: true,
      population: false,
      airPointLine: false,
      showairPort: true, //显示隐藏起降点
      showNormalairPort: false, //显示隐藏普通航点
      closeRadar: null,
      showDubuleLine: false,
      lineLength: {}, //单条航迹的长度
      allLineLength: {}, //所有航迹点长度
      planKeyWord: "", //任务搜索关键词
      airSpaceTableData: [],
      showAirSpace: false,
      tableData: [],
      planePointData: [], //飞机平滑移动用于记录飞机位置信息
      showAirLine: false,
      showlineall: true,
      searchTaskKeyWord: "",
      taskList: [],
      wbsNum: 0, //获取websocket信息次数奇数的时候调用获取高度速度曲线
      openLeft: true, //展开左侧
      planeChartData: [], //飞机高度速度曲线数据
      planeDetailData: {}, //飞机详情数据
      isSimplifyTooltip: true, //是否精简标牌
      isDisplayCommunicationEquipment: false, //是否展示通信设备
      isDisplayMonitorEquipment: false, //是否展示视频设备
      isDisplayNavigationEquipment: false, //是否展示导航设备
      isDisplayWeatherEquipment: false, //是否展示气象设备
      isDisplayCountermeasureEquipment: false, //是否展示反制设备
      showADSB: false, //是否展示ADSB设备
      showOneRadar: false, //是否展示一次雷达设备
      communicationEquipmentData: [], //通信设备数据
      monitorEquipmentData: [], //监视设备数据
      navigationEquipmentData: [], //导航设备数据
      weatherEquipmentData: [], //气象设备数据
      countermeasureEquipmentData: [], //反制设备数据
      ADSBEquipmentData: [], //ADSB设备数据
      oneRadarEquipmentData: [], //一次雷达设备数据
      ADSBEquipmentTag: [], //ADSB设备图标
      communicationEquipmentTag: [], //通信设备图标
      monitorEquipmentTag: [], //监视设备图标
      navigationEquipmentTag: [], //导航设备图标
      weatherEquipmentTag: [], //气象设备图标
      countermeasureEquipmentTag: [], //反制设备图标
      oneRadarEquipmentTag: [], //一次雷达设备图标

      clickPlaneInfo: {}, //显示实时飞行的飞机详情
      isDetailOpen: true,
      active1: false, //航迹是否点击
      active2: false, //标牌
      active3: false, //航线
      active4: false, //空域
      active5: false, //航点
      active6: false, //气象
      isShowVideo: false,
      i: 0,
      map: null,
      // center: [32.06, 118.8],//南京
      // center: [24.9402, 118.1806],//南安
      // center: [25.20249487751626, 118.44143629074098],//南安九都镇
      center: [31.2995549, 121.4511], //上海市静安区
      // center: [34.34, 108.80], //西咸新区
      activeLayer: 0, //目前的图层
      isEnvelope: true, //是否显示包络
      clickstar: true,
      clickroad: false,
      currentZoom: 1, //当前地图缩放级别
      originLayer:
        "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}",
      roadUrlTemplate:
        "https://wprd01.is.autonavi.com/appmaptile?langzh_cn&size=1&scale=1&style=8{ltype}&x={x}&y={y}&z={z}",
      satelliteUrlTemplate:
        "https://webst01.is.autonavi.com/appmaptile?langzh_cn&size=1&style=6&x={x}&y={y}&z={z}",
      //数据
      showWeather: true, //气象是否点击
      alarmed: false,
      warninged: false,
      tooltipPermanent: false, //标牌展示隐藏
      updateTooltip: false, //是否进行更新标牌显隐属性操作
      infoArr: [], //多个航点实时数据
      uasId: null, //点击的当前点要展示航迹的点id
      openPopup: false, //是否展示锁定航点的弹框
      oldOrderId: [], //所有orderID
      markerPointData: [], //地图上创建的所有航点以及对应航点信息
      runTask: [], //执行中计划
      preTask: [], //待执行计划
      doneTask: [], //已执行计划
      realTask: [], //预警告警事件
      // alarmMarker: [], //预警告警点数据
      meteoActive: 0, //当前气象模式
      showAirspaceAll: true,
      //地图内容(可能需要清除)

      //正在执行

      //单个
      polyline: null, //单个航迹（当前点击的）
      trackLines: [], // 包含实线和虚线的航迹数组
      runlineWhites: [], //单个航迹白底
      //所有执行中
      markerPoints: [], //所有实时更新的飞行器
      runLineMarkers: [], //所有执行航线的（航点）
      runLines: [], //所有执行中的航线
      runRoadWhites: [], //航线白底
      allPolyline: [], //所有实时航迹
      allPolylines: [], //航迹白底

      //计划待执行
      //单个
      positionLines: null, //定位的航线
      positRoadWhite: null, //定位航线的白底

      //所有计划待执行
      airLinePositions: [], //所有当前定位航线的航点
      airLinePorts: [], //所有计划航线的（航点）
      planLines: [], //所有计划航线
      planlineWhite: [], //航线白底

      //所有数据
      airSpaces: [], //所有空域
      airPorts: [], //所有航点（包含起降点）

      //其他
      heatLayer: null, //绘制的热力图
      velocityLayer: null, //绘制的风速矢量图
      weatherInfo: {
        province: "",
        city: "",
        reporttime: "",
        temperature: "",
        winddirection: "",
        windpower: ""
      }, //气象数据
      imgCondition: {
        sunny: false,
        rain: false,
        cloudy: false, //多云
        yin: false
      }, //气象图片
      runMarkers: [], //getlastpoint接口获取的点
      toolTip: "",
      runPlaneID: [], //正在执行的飞机的ID
      distanceLabels: [], // 用于存储距离标签
      circles: [], // 创建圆环数组
      centerMarker: null, //圆环中心标记
      isCircle: false, //距离环是否开启
      markers: null, // 标记聚合
      searchFormVisible: false, //搜飞机的对话框
      searchForm: {
        uasID: "" // 飞机序列号
      },
      uavSerials: [], // 飞机序列号列表
      isMannualClose: false, // 是否手动关闭
      southWestLat: "", // 西南角纬度
      southWestLng: "", // 西南角经度
      northEastLat: "", // 东北角纬度
      northEastLng: "", // 东北角经度
      singleLine: [],
      searchKey3: "", //搜索执行中的计划
      searchKey2: "", // 搜索待执行的计划
      searchKey1: "", // 搜索实时事件
      oldEllipse: [], // 之前椭圆包络
      showCounter: false, //是否显示反制无人机
      videoUrl: "http://localhost:8080/videoplayer/50/hls.m3u8", //视频流流地址
      videoName: "",
      hls: null,
      countermeasurePopMakers: [], //反制功能marker
      countermeasureWorking: false //是否在反制
    };
  },
  computed: {
    allEyesModel() {
      return this.isBigScreen ? this.isEyeshield : this.isStyleApplied
    }
  },
  mounted() {
    // this.startNotice()
    this.isShowVideo && this.startVideo();
    this.initMap();
    this.planeAllWay();
    this.airSpace();
    this.drawRadarChart();
    this.callweather();
    if (this.ws) {
      this.getLastStatus()
    }
    window.addEventListener("message", e => {
      if (e.data == "changeLayerType") {
        if (this.active3) {
          this.planeAllWay();
        }
        if (this.active4) {
          this.airSpace();
        }
      }
    });
    //10s更新气象设备
     window.weatherTimer = setInterval(()=>{
      if(this.isDisplayWeatherEquipment){
        this.getRequest(
          '/uav-task-server/weatherEquipment/queryWeatherInfo'
        ).then(
          res => {
            let data = res.data.data
            data.map(v=>{

              v.info&&this.weatherEquipmentTag.map((marker, index) => {
                let toolTipObj = marker.getTooltip()
                // console.log(toolTipObj)
                if(toolTipObj&&toolTipObj.getContent().includes(v.weatherEquipment.name)){
                  toolTipObj.setContent(`<div class="weather" >
                  <div class="top">
                    <div class="address">
                      ${v.weatherEquipment.name}
                    </div>
                  </div>
                  <div class="content">
                    <div class="temperature">
                      ${v.info.temp}℃ &nbsp;

                    </div>
                    <div class="params">
                      <span>大气压强：${v.info.atm}kPa</span>
                    </div>
                    <div class="params">
                      <span>降雨量：${v.info.precipitation}mm</span>&nbsp;&nbsp;
                      <span>噪音：${v.info.noise}dB</span>
                    </div >
                    <div class="bottom params"  style="display: flex;justify-content: space-between">
                      <span>风速：${v.info.windspeed}</span>
                      <span>风向：${v.info.windDirection}</span>
                      <span>湿度：${v.info.hum}</span>
                    </div>
                  </div>
                </div>`)
                }
              });
            })
          })
        }
      },10000)
  },
  beforeDestroy() {
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }
    if (window.weatherTimer) {
      clearInterval(window.weatherTimer);
      window.weatherTimer = null;
    }
    if (window.predictionTimer) {
      clearInterval(window.predictionTimer);
      window.predictionTimer = null;
    }
    if (this.hls) {
      this.hls.destroy(); // 断开 HLS 连接
      this.hls = null;
    }
    //雷达
    if (this.closeRadar) {
      this.closeRadar();
    }
  },
  created() {
    // 创建防抖函数
    this.debouncedChangeLine = _.debounce(this.changeLineShow, 500);
    this.debouncedChangeAirPot = _.debounce(this.changeAirPotShow, 500);
    this.debouncedChangeormalAirPot = _.debounce(
      this.changeNormalAirPotShow,
      500
    );
  },
  methods: {
    handelairPointLine() {
      this.airPointLineChecked = !this.airPointLineChecked;
      this.airPointLine = !this.airPointLine;
      if (!this.airPointLineChecked) {
        if (this.showAirLine) {
          this.showAirLine = false;
        }
      }
    },
    handelAirSpace() {
      this.airSpaceChecked = !this.airSpaceChecked;
      this.area = !this.area;
      if (!this.airSpaceChecked) {
        this.showAirSpace = false;
      }
    },
    //切换航线名显示隐藏
    changeAirLineName() {
      this.showAirLineName = !this.showAirLineName
      this.planLines.map(v => {
        if (this.showAirLineName && this.currentZoom > 10) {
          v.openTooltip();
        } else {
          v.closeTooltip();
        }
      })
    },
    addMapElement(key){
      switch(key){
        case "roadNetwork":
          this.roadNetworkObj = L.geoJSON(luwangGeoJson, {
            style: {
              color: this.isStyleApplied ? 'rgba(192, 240, 237,1)' : 'rgba(192, 240, 237,1)', // 城市边界颜色
              weight: 2,
              fillColor: this.isStyleApplied ? 'rgb(192, 240, 237,0.6)' : 'rgb(192, 240, 237,0.6)', // 填充颜色
              fillOpacity: 0.48, // 填充透明度
            }
          }).addTo(this.map);
          break;
        case "greenPart":
          this.greenPartObj = L.geoJSON(greenPartGeoJsont, {
            style: {
              color: this.isStyleApplied ? 'rgba(124,252,0,1)' : 'rgba(124,252,0,1)', // 城市边界颜色
              weight: 2,
              fillColor: this.isStyleApplied ? 'rgb(124,252,0,0.4)' : 'rgb(124,252,0,0.4)', // 填充颜色
              fillOpacity: 0.48, // 填充透明度
            }
          }).addTo(this.map);
          break;
        case  "river":
          this.riverObj = L.geoJSON(riverGeoJson, {
            style: {
              color: this.isStyleApplied ? 'rgba(30,144,255,1)' : 'rgba(30,144,255,1)', // 城市边界颜色
              weight: 2,
              fillColor: this.isStyleApplied ? 'rgb(30,144,255,0.6)' : 'rgb(30,144,255,0.6)', // 填充颜色
              fillOpacity: 0.48, // 填充透明度
            }
          }).addTo(this.map);
          break;

      }
    },
    //显示路网地图元素
    handelShowRoadNetwork(){
      this.showRoadNetwork = !this.showRoadNetwork
      if(this.showRoadNetwork){
        this.addMapElement("roadNetwork")
      }else if(this.roadNetworkObj){
        this.map.removeLayer(this.roadNetworkObj)
      }
    },
    //显示绿地地图元素
    handelShowGreenPart(){
      this.showGreenPart = !this.showGreenPart
      if(this.showGreenPart){
        this.addMapElement("greenPart")
      }else if(this.greenPartObj){
        this.map.removeLayer(this.greenPartObj);
      }
    },
    //显示水系图元素
    handelShowRiver(){
      this.showRiver = !this.showRiver
      if(this.showRiver){
        this.addMapElement("river")
      }else if(this.riverObj){
        this.map.removeLayer(this.riverObj);
      }
    },
    updateTheme() {
      const tileImages = document.querySelectorAll(".leaflet-tile-pane img");
      if (!this.isEyeshield) {
        tileImages.forEach(img => {
          img.classList.remove("sepia-grayscale");
        });
      } else {
        tileImages.forEach(img => {
          img.classList.add("sepia-grayscale");
        });
      }
    },
    //更新航线toolTip name 是否展示
    updateAirLineNameStatus() {
      if (this.planLines.length) {
        const shouldBe = this.currentZoom > 10;
        this.planLines.forEach(line => {
          if (shouldBe) {
            line.openTooltip();
          } else {
            line.closeTooltip();
          }
        });
      }
    },
    getTypeText(type) {
      if (type === 0) {
        return "禁飞区";
      } else if (type === 1) {
        return "电子围栏";
      } else if (type === 3) {
        return "适飞区";
      } else if (type === 4) {
        return "限飞区";
      } else if (type >= 11 && type <= 19) {
        return "管制空域";
      } else if (type >= 21 && type <= 29) {
        return "监视空域";
      }
      return "未知类型";
    },
    addHot() {
      if (this.relituChecked) {
        var jsonShanghaiData = jsonData;

        // 处理 JSON 数据，转换为 leaflet.heat 插件所需的格式
        var heatData = jsonShanghaiData.map(function (item) {
          const point = wgs84ToGcj02(item.lng, item.lat);

          return [point[1], point[0], item.count];
        });

        // 调用渲染方法，传入半径，透明度参数，添加到地图
        this.heatLayer = L.heatLayer(heatData, {
          radius: 25
          // blur: 15,
        }).addTo(this.map);
      } else {
        if (this.heatLayer) {
          this.map.removeLayer(this.heatLayer);
        }
      }
    },
    showMask() {
      // 加载城市的 GeoJSON 数据
      this.getRequest("/uav-task-server/airspace/getShanghaiGeoJson").then(
        res => {
          const oData = res.data;
          if (oData.code === 0) {
            const cityGeoJSON = JSON.parse(oData.data);
            // 创建一个城市图层
            // 创建城市的图层并添加到地图
            this.cityLayer = L.geoJSON(cityGeoJSON, {
              style: {
                color: this.allEyesModel
                  ? "rgba(214,211,241,1)"
                  : "rgba(255,254,190,1)", // 城市边界颜色
                weight: 2,
                fillColor: this.allEyesModel
                  ? "rgb(219,217,255,0.48)"
                  : "rgb(255,246,141,0.48)", // 填充颜色
                fillOpacity: 0.48 // 填充透明度
              }
            }).addTo(this.map);
          }
        }
      );
    },
    //切换航线显示
    changeLineShow() {
      this.showDubuleLine = !this.showDubuleLine;
      this.planeAllWay();
    },
    changeAirPotShow() {
      if (this.airLinePorts.length > 0) {
        this.airLinePorts.forEach(point => {
          this.map.removeLayer(point);
        });
        this.airLinePorts = [];
      }
      if (this.airLinePositions.length > 0) {
        this.airLinePositions.forEach(marker => {
          this.map.removeLayer(marker);
          this.airLinePositions = [];
        });
      }
      this.showairPort = !this.showairPort;
      let queryCode;
      if (this.selectedDistrict == 0) {
        if (this.selectCity == 0) {
          queryCode = this.selectProvince;
        } else {
          queryCode = this.selectCity;
        }
      } else {
        queryCode = this.selectedDistrict;
      }
      this.planeAllWay(queryCode);
    },
    changeNormalAirPotShow() {
      if (this.airLinePorts.length > 0) {
        this.airLinePorts.forEach(point => {
          this.map.removeLayer(point);
        });
        this.airLinePorts = [];
      }
      if (this.airLinePositions.length > 0) {
        this.airLinePositions.forEach(marker => {
          this.map.removeLayer(marker);
          this.airLinePositions = [];
        });
      }
      this.showNormalairPort = !this.showNormalairPort;
      let queryCode;
      if (this.selectedDistrict == 0) {
        if (this.selectCity == 0) {
          queryCode = this.selectProvince;
        } else {
          queryCode = this.selectCity;
        }
      } else {
        queryCode = this.selectedDistrict;
      }
      this.planeAllWay(queryCode);
    },
    torAdarDerail() {
      sessionStorage.setItem("selectMenuIndex", "radar");
      this.$emit("change-menu", "radar");
    },
    drawRadarChart() {
      const canvas = document.getElementById("radarChart");
      const ctx = canvas.getContext("2d");
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = 120;
      let angle = 0;
      const trailFade = 0.05;
      const numCircles = 5;
      const innermostRadius = radius * (1 / numCircles);
      const trailLength = 20; // 拖尾长度
      const trailAngles = []; // 存储拖尾的角度
      let animationFrameId; // 用于存储 requestAnimationFrame 的 ID

      function drawRadar() {
        // 绘制透明背景
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = `rgba(0, 0, 0, ${trailFade})`;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // 创建径向渐变
        const gradient = ctx.createRadialGradient(
          centerX,
          centerY,
          0,
          centerX,
          centerY,
          radius
        );
        gradient.addColorStop(0, "rgba(0, 255, 0, 0.8)");
        gradient.addColorStop(1, "rgba(0, 0, 0, 0)");

        // 绘制渐变圆形
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
        ctx.fillStyle = gradient;
        ctx.fill();

        // 绘制外圆边框
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
        ctx.strokeStyle = "#0f0";
        ctx.lineWidth = 2;
        ctx.stroke();

        // 绘制十字线
        ctx.beginPath();
        ctx.moveTo(centerX - radius, centerY);
        ctx.lineTo(centerX + radius, centerY);
        ctx.moveTo(centerX, centerY - radius);
        ctx.lineTo(centerX, centerY + radius);
        ctx.strokeStyle = "#0f0";
        ctx.lineWidth = 1;
        ctx.stroke();

        // 绘制同心圆
        for (let i = 1; i <= numCircles; i++) {
          const circleRadius = radius * (i / numCircles);
          ctx.beginPath();
          ctx.arc(centerX, centerY, circleRadius, 0, 2 * Math.PI);
          ctx.strokeStyle = "#0f0";
          ctx.lineWidth = 1;
          ctx.stroke();

          // 绘制角点数字
          if (i % 2 !== 0) {
            const textX = centerX + circleRadius;
            const textY = centerY;
            ctx.font = "15px Arial";
            ctx.fillStyle = "#fff";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(i + 1 + "km", textX, textY);
          }
        }

        // 绘制拖尾
        for (let i = 0; i < trailAngles.length; i++) {
          const trailAngle = trailAngles[i];
          const alpha = 0.6 * (1 - i / trailLength);
          ctx.beginPath();
          ctx.moveTo(centerX, centerY);
          const trailEndX = centerX + radius * Math.cos(trailAngle);
          const trailEndY = centerY + radius * Math.sin(trailAngle);
          ctx.lineTo(trailEndX, trailEndY);
          ctx.strokeStyle = `rgba(0, 255, 0, ${alpha})`;
          ctx.lineWidth = 2;
          ctx.stroke();
        }

        // 绘制当前扫描线
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        const endX = centerX + radius * Math.cos(angle);
        const endY = centerY + radius * Math.sin(angle);
        ctx.lineTo(endX, endY);
        ctx.strokeStyle = "rgba(0, 255, 0, 0.8)";
        ctx.lineWidth = 2;
        ctx.stroke();

        // 检查点是否可见

        // 更新拖尾角度数组
        trailAngles.unshift(angle);
        if (trailAngles.length > trailLength) {
          trailAngles.pop();
        }

        // 更新角度
        angle += 0.01;
        if (angle >= 2 * Math.PI) {
          angle = 0;
        }

        // 递归调用 drawRadar 函数
        animationFrameId = requestAnimationFrame(drawRadar);
      }

      drawRadar();
      // 添加关闭方法
      this.closeRadar = function () {
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }
      };
    },
    sendData() {
      this.sendDataChecked = true;
      setTimeout(() => {
        this.$message({
          message: "发送成功",
          duration: 1000,
          customClass: "message-s",
          iconClass: "el-icon-ok-tip",
          offset: 470,
          onClose: function () { }
        });
        this.sendDataChecked = false;
      }, 2000);
    },
    // 获取图标 URL 的方法
    getIconUrl(info) {
      //uavType  1 多旋翼 2复合翼
      let iconUrl = "../../../static/wurenji_normal.png";
      if (info.uavType === 1) {
        if (
          info.alarm ||
          info.warning ||
          (info.conflictsList && info.conflictsList.length) ||
          info.black
        ) {
          iconUrl = "../../../static/wurenji_yichang.png";
        } else if (info.uasID === this.uasId) {
          iconUrl = "../../../static/wu_ren_ji__click.png";
        }
      } else if (info.uavType === 2) {
        if (
          info.alarm ||
          info.warning ||
          (info.conflictsList && info.conflictsList.length) ||
          info.black
        ) {
          iconUrl = "../../../static/feiji_yichang.png";
        } else if (info.uasID === this.uasId) {
          iconUrl = "../../../static/feiji_yichang_click.png";
        } else {
          iconUrl = "../../../static/feiji_normal.png";
        }
      } else if (info.uavType === 3) {
        iconUrl = "../../../static/civil_wurenji.png";
      } else if (info.uavType === 4) {
        iconUrl = "../../../static/wurenji_fanzhi.png";
      } else if (info.uavType === 5) {
        if (
          info.alarm ||
          info.warning ||
          (info.conflictsList && info.conflictsList.length) ||
          info.black
        ) {
          iconUrl = "../../../static/evtol_yichang.png";
        } else if (info.uasID === this.uasId) {
          iconUrl = "../../../static/evtol_click.png";
        } else {
          iconUrl = "../../../static/evtol_normal.png";
        }
      }
      return iconUrl;
    },
    //获取标牌信息
    updateToolTipHtml(info) {
      //高度、速度、航迹角
      let altitude =
        info.altitude != null ? Number(info.altitude).toFixed(2) + " m" : "/";
      let gs = info.gs != null ? Number(info.gs).toFixed(2) + " m/s" : "/";
      let height =
        info.height != null ? Number(info.height).toFixed(2) + " m" : "/";
      let course = info.course != null ? info.course + " °" : "/";
       this.isSimplifyTooltip
        ? (this.toolTip = `
        <div class="content">
        <div class='tag' >
                <div  style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">${info.uasID != null ? info.uasID : "/"
        }</div>
              <div >${info.modelName || info.uavModel || "/"}</div>
              <div>${altitude}</div>
              <div>${gs}</div>
          </div>
        </div>`)
        : (this.toolTip = `
        <div class="content">
          <div class="title" style="margin-left: 8px;overflow: hidden;width:200px;text-overflow: ellipsis;white-space: nowrap;">${info.uasID != null ? info.uasID : "/"
        }</div>
          <div class='tag'>
              <div >计划编号:${planNoContent}</div>
              <div >飞机型号:${info.modelName || info.uavModel || "/"}</div>
              <div >经度:<span>${info.longtitude != null
          ? this.decimalToDMS(info.longtitude)
          : "/"
        }</span>
              </div>
              <div >纬度:<span>${info.latitude != null ? this.decimalToDMS(info.latitude) : "/"
        }</span>
              </div>
              <div >海拔高:<span>${altitude}</span></div>
              <div >真高:<span>${height}</span></div>
              <div>速度:<span>${gs}</span></div>
              <div >航迹角:<span>${course}</span></div>
            ${alarmDiv}
          </div>
        </div>`);
    },
    // 获取告警信息的方法
    getAlarmDiv(info) {
      if (info.warning) {
        return "<div>预警:<span>即将偏离航线</span></div>";
      }
      if (info.alarm) {
        return "<div>告警:<span>已偏离航线</span></div>";
      }
      if (info.black) {
        return "<div>告警:<span>黑飞</span></div>";
      }
      return "";
    },
    createMarker(info, type) {
      const iconUrl = this.getIconUrl(info);
      // if(info.uasID=="F1200"||info.uasID=="F1800"){
      //   iconUrl = "../../../static/wurenji_yichang.png";
      // }
      let iconSize = this.typeMap[info.uavType]
      //设置图标样式
      let myIcon = L.divIcon({
        html: `<div id="planeMarker" class="planeMarker ${!this.isEnvelope ? "planeMarkerActive" : ""
          } "  ><img src=${iconUrl} alt=" " class="${this.typeMarkerSizeMap[info.uavType]
          }"></div>`,
        className: "planeMarker", // 添加我们定义的CSS类
        iconSize: [iconSize, iconSize],
        iconAnchor: [iconSize / 2, iconSize / 2]
      });
      let point = wgs84ToGcj02(info.longtitude, info.latitude);
      // this.map.setView([point[1], point[0]], 12)
      // // console.log("marker" + this.i++);
      let rotateAngle = info.course; //航迹角 正北方向为0度，顺时针旋转
      let markerPoint = L.marker([point[1], point[0]], {
        icon: myIcon,
        zIndexOffset: 9001, // 设置一个较高的z-index值
        rotationAngle: rotateAngle, //根据航迹角来进行飞机的旋转
        rotationOrigin: "center center", //设置旋转中心
        draggable: true
      }).addTo(this.map);
      // 图标根据地图放缩大小
      let _this = this;

      function getIconSize() {
        const zoomLevel = _this.map.getZoom();
        const size = Math.min(35, zoomLevel * 2); // 根据缩放级别调整大小
        return L.divIcon({
          html: `<div id="planeMarker" class="planeMarker ${!_this.isEnvelope ? "planeMarkerActive" : ""
            } "  ><img src=${iconUrl} alt=" " class="${this.typeMarkerSizeMap[info.uavType]
            }"></div>`,
          className: "planeMarker", // 添加我们定义的CSS类
          iconSize: size, // 图标大小
          iconAnchor: [size / 2, size],
          rotationAngle: rotateAngle, //根据航迹角来进行包络的旋转
          rotationOrigin: "center center" //设置旋转中心
        });
      }

      // 更新标记图标
      function updateMarker() {
        const newIcon = getIconSize();
        markerPoint.setIcon(newIcon);
      }

      // updateMarker()
      // 监听地图缩放事件
      // this.map.on('zoomend', updateMarker);
      // 将 markerToTop 提升
      //点添加标牌以及样式
      let planNoContent = info.planNo
        ? `<span>${info.planNo}</span>`
        : `<span>无计划</span>`;
      //告警预警
      var alarmDiv = "";
      if (info.warning) {
        alarmDiv = "<div>预警:<span>即将偏离航线</span></div>";
      }
      if (info.alarm) {
        alarmDiv = "<div>告警:<span>已偏离航线</span></div>";
      }
      if (info.black) {
        alarmDiv = "<div>告警:<span>黑飞</span></div>";
      }
      if (type === "envelope") {
        var iconElement = markerPoint.getElement();
        if (info.alarm || info.warning || info.black) {
          // 开始闪烁
          iconElement && iconElement.classList.add("blinking");
        } else if (!info.alarm && !info.warning && info.black) {
          // 停止闪烁
          iconElement && iconElement.classList.remove("blinking");
        }
      }
      this.updateToolTipHtml(info)
      markerPoint.bindTooltip(this.toolTip, {
        //内容可以自定义为HTML，如：<div>自定义结构</div>
        autoPan: false,
        zIndexOffset: 1100,
        direction: "bottom", // 显示在底部
        permanent: this.tooltipPermanent || this.uasId === info.uasID, // 永久打开提示
        offset: [0, iconSize / 2], // 向下偏移
        className: this.isSimplifyTooltip ? "simplifyTooltip" : "anim-tooltip" // 自定义class
      });
      //飞机点击事件
      markerPoint.on("click", e => {
        this.singleLine = []; //清空航迹数组
        this.clearSingleLine()
        //更新图标颜色
        if (this.uasId !== info.uasID) {
          //开启实时更新航线
          this.openPopup = true;
          this.uasId = info.uasID;
          if(!this.active1){
            this.addPolyline(this.uasId); // 点击后请求后端接口绘制航迹
          }
          // setTimeout(() => {
          //   this.addPolyline(this.uasId); // 点击后请求后端接口绘制航迹
          // }, 2000);
          //获取飞机详情速度高度曲线数据
          this.uasId = info.uasID;
        } else if (this.uasId === info.uasID) {
          this.uasId = null;
        }
        this.markerPointData.map(item => {
          const newIconUrl = this.getIconUrl(item.info);
          let newHtml = `<div id="planeMarker" class="planeMarker ${!this.isEnvelope ? "planeMarkerActive" : ""
            } "  ><img src=${newIconUrl} alt=" " class="${this.typeMarkerSizeMap[item.info.uavType]
            }"></div>`;
          const newIcon = L.divIcon({
            html: newHtml,
            className: "planeMarker",
            iconSize: [
              item.markerPoint.options.icon.options.iconSize[0],
              item.markerPoint.options.icon.options.iconSize[1]
            ],
            iconAnchor: [
              item.markerPoint.options.icon.options.iconAnchor[0],
              item.markerPoint.options.icon.options.iconAnchor[1]
            ]
          });

          //更新点击飞机图标
          item.markerPoint.setIcon(newIcon);
          //更新标牌
          this.updateToolTipHtml(item.info)
          item.markerPoint.bindTooltip(this.toolTip, {
            //内容可以自定义为HTML，如：<div>自定义结构</div>
            autoPan: false,
            zIndexOffset: 1100,
            direction: "bottom", // 显示在底部
            permanent:
              this.tooltipPermanent || this.uasId === item.info.uasID, // 永久打开提示
            offset: [0, iconSize / 2], // 向下偏移
            className: this.isSimplifyTooltip
              ? "simplifyTooltip"
              : "anim-tooltip" // 自定义class
          });
        });
      });
      var iconElement = markerPoint.getElement();
      if (info.alarm || info.warning || info.black) {
        // 开始闪烁
        iconElement && iconElement.classList.add("blinking");
      } else if (!info.alarm && !info.warning && info.black) {
        // 停止闪烁
        iconElement && iconElement.classList.remove("blinking");
      }

      this.markerPoints.push(markerPoint);
      this.markerPointData.push({ markerPoint: markerPoint, info: info });
      //绘制点加到地图之后画航迹保证轨迹在后
        if (this.active1) {
          setTimeout(()=>{
            this.addPolyAllline();
          },2000)

        }
    },
    handelShowLine(v, id) {
      this.deletePlaneAllWay();
      this.planeAllWay();
    },
    handelShowAirSpace(v, id) {
      this.daleteAirSpace();
      this.airSpace();
    },
    showAll() {
      if (!this.showlineall) {
        this.tableData.forEach(v => {
          v.isShowLine = true;
        });
        this.deletePlaneAllWay();
        this.planeAllWay();
        this.showlineall = !this.showlineall;
      } else {
        this.tableData.forEach(v => {
          v.isShowLine = false;
        });
        this.deletePlaneAllWay();
        this.showlineall = !this.showlineall;
      }
    },
    showAllAirSpace() {
      if (!this.showAirspaceAll) {
        this.airSpaceTableData.forEach(v => {
          v.isShowAirSpace = true;
        });
        this.daleteAirSpace();
        this.airSpace();
        this.showAirspaceAll = !this.showAirspaceAll;
      } else {
        this.airSpaceTableData.forEach(v => {
          v.isShowAirSpace = false;
        });
        this.daleteAirSpace();
        this.showAirspaceAll = !this.showAirspaceAll;
      }
    },
    startNotice() {
      const announcementList = document.querySelector(".announcement-list");
      const items = document.querySelectorAll(".announcement-item");
      const itemHeight = 40; // 每个公告的高度
      let currentIndex = 0;
      // 克隆第一个公告项以实现无缝滚动
      const firstItemClone = items[0].cloneNode(true);
      announcementList.appendChild(firstItemClone);

      function showNextAnnouncement() {
        currentIndex++;
        const offset = -currentIndex * itemHeight; // 更新位置
        announcementList.style.transform = `translateY(${offset}px)`; // 更新位置
        // 当滚动到最后一个公告时，重置位置
        if (currentIndex >= items.length) {
          // 等待动画结束后重置位置
          setTimeout(() => {
            announcementList.style.transition = "none"; // 取消过渡
            announcementList.style.transform = "translateY(0)"; // 重置位置
            currentIndex = 0; // 重置索引
          }, 500); // 等待动画结束
        }
      }

      setInterval(() => {
        showNextAnnouncement();
        announcementList.style.transition = "transform 0.5s ease"; // 确保过渡效果
      }, 3000); // 每3秒切换
    },
    initMap() {
      //定义图层样式
      var layer = L.tileLayer(
        this.satelliteUrlTemplate
        // "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}"
      );
      //创建地图
      var map = L.map("map-container", {
        center: this.center, //中心坐标
        // zoom: 10, //缩放级别
        zoom: 15, //缩放级别
        minZoom: 3,
        maxZoom: 18,
        zoomControl: true, //缩放组件
        attributionControl: false, //去掉右下角logol
        layers: [layer] //图层
      });
      this.map = map;
      this.currentZoom = map.getZoom();
      this.showMask(); //遮罩
      let _this = this;
      // 初始化Leaflet.draw控件
      var drawnItems = new L.FeatureGroup();
      this.map.addLayer(drawnItems);
      // 绘制控件初始化代码...
      this.drawControl = new L.Control.Draw({
        draw: {
          polyline: {
            shapeOptions: {
              color: "red", // 设置绘制线条的颜色
              opacity: 0.8
            },
            allowIntersection: false,
            showLength: true,
            metric: true // 使用公制单位进行测量
          },
          polygon: false,
          rectangle: false,
          circle: false,
          marker: false,
          circlemarker: false
        }
      });
      // 将绘制控件添加到地图上
      this.map.addControl(this.drawControl);

      // 地图加载完成后再执行操作
      map.whenReady(() => {
        if (_this.isBigScreen) {
          _this.updateTheme();
        } else {
          _this.$emit("update-theme");
        }
        // // 创建初始圆环
        // _this.createCircles();
        // 监听地图移动事件
        map.on("moveend", function () {
          _this.updateCirclesPosition();
          _this.getBounds();

          if (_this.isBigScreen) {
            _this.updateTheme();
          } else {
            _this.$emit("update-theme");
          }
          // _this.sendBounds();
        });
        //监听地图缩放
        map.on("zoomend", function () {
          // 获取当前缩放级别
          _this.currentZoom = map.getZoom();
          // _this.updatePolylineWeight();
          _this.updateCirclesPosition();
          _this.getBounds();

          if (_this.isBigScreen) {
            _this.updateTheme();
          } else {
            _this.$emit("update-theme");
          }
          // _this.sendBounds();
          if (_this.showAirLineName) {
            _this.updateAirLineNameStatus();
          }
        });
        //定位用户地理位置
        // this.getUserLocation();
        if (this.isBigScreen) {
          this.getLastStatus();
        }
        this.queryPlan();
        // window.queryTimer = setInterval(this.getLastStatus, 2000);
        window.queryTaskTimer = setInterval(this.queryPlan, 10000);

        // 监听绘制事件
        let that = this;
        map.on("draw:created", function (event) {
          // 将绘制的图层添加到地图上
          var layer = event.layer;
          // 获取图层类型
          var layerType = event.layerType;
          drawnItems.addLayer(layer);
          that.drawnItems = drawnItems;
          if (layerType === "polyline") {
            // 确保 layer 对象存在
            if (layer) {
              // 获取线上的所有顶点
              let latlngs = layer.getLatLngs();
              // 初始化一个数组来存储所有顶点的坐标
              let points = [];
              latlngs.forEach(item => {
                points.push([item.lng, item.lat]);
              });
              // console.log('顶点', points);
              // 初始化距离变量
              let totalDistance = 0;
              // 遍历所有顶点，‌计算相邻顶点之间的距离，‌并累加
              for (let i = 0; i < latlngs.length - 1; i++) {
                let startPoint = latlngs[i];
                let endPoint = latlngs[i + 1];
                // 计算两点之间的距离，‌并累加到总距离中
                totalDistance += startPoint.distanceTo(endPoint);
              }
              const distanceLabel = L.divIcon({
                className: "distance-label",
                html: `<div class="distance"><span class="label">共${(
                  totalDistance / 1000
                ).toFixed(2)} km</span><span id="close-icon-${layer._leaflet_id
                  }"><i class="el-icon-close"></i></span></div>`
              });
              const labelPosition = layer.getLatLngs()[
                layer.getLatLngs().length - 1
              ];
              const marker = L.marker(labelPosition, { icon: distanceLabel });
              that.showRange = false;
              marker.on("add", function () {
                const closeIconId = `close-icon-${layer._leaflet_id}`;
                const closeIcon = document.getElementById(closeIconId);
                if (closeIcon) {
                  closeIcon.addEventListener("click", () => {
                    that.handleDeleteDistance(layer, marker);
                  });
                }
              });
              marker.on("remove", function () {
                const closeIconId = `close-icon-${layer._leaflet_id}`;
                const closeIcon = document.getElementById(closeIconId);
                if (closeIcon) {
                  closeIcon.removeEventListener("click", () => {
                    that.handleDeleteDistance(layer, marker);
                  });
                }
              });
              map.addLayer(marker);
              that.distanceLabels.push({ layer, label: distanceLabel });
            } else {
              console.error("Layer is undefined or null");
            }
          }
        });
      });
    },
    handleConfirmCountermeasure(status, deviceId) {
      return this.postJsonRequest(
        "/uav-task-server/countermeasureEquipment/trick",
        {
          longitude: 121.123123,
          latitude: 23.1231234,
          altitude: 123,
          height: 321,
          trickMode: status, //打开4  关闭1
          deviceId: deviceId
        }
      ).then(res => {
        if (res.data.code === 0) {
          this.countermeasureWorking = !this.countermeasureWorking;
          this.$message({
            message: res.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () { }
          });
        }
      });
    },
    changeDetailOpen(v) {
      this.isDetailOpen = v;
    },
    //播放视频
    startVideo() {
      const video = this.$refs.video;
      // 检查浏览器是否支持 HLS.js
      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.videoUrl);
        this.hls.attachMedia(video);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play();
        });
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        // 直接播放 HLS 流
        video.src = this.videoUrl;
        video.addEventListener("loadedmetadata", () => {
          video.play();
        });
      }
    },
    closeVideo() {
      const video = this.$refs.video;
      if (this.hls) {
        this.hls.destroy(); // 断开 HLS 连接
        this.hls = null;
      }
      video.pause();
      this.isShowVideo = false;
    },
    handleOpenLeft() {
      this.openLeft = !this.openLeft;
    },
    callplayWay() {
      this.active1 = !this.active1;
      // if (this.active1) {
      // } else {
      // }
      this.handleChildMessage(this.active1);
      // this.$emit("messageFromChild", this.active1);
    },
    callPlanWay() {
      // this.active3 = !this.active3;
      // if (this.active3) {
      //   this.planeAllWay();
      // } else {
      //   this.deletePlaneAllWay();
      // }
      if (this.showAirSpace) {
        this.showAirSpace = false;
      }
      this.showAirLine = !this.showAirLine;
    },
    callairSpace() {
      if (this.showAirLine) {
        this.showAirLine = false;
      }
      this.showAirSpace = !this.showAirSpace;
    },
    callairport() {
      this.active5 = !this.active5;
      if (this.active5) {
        this.airPort();
      } else {
        this.daleteAirPort();
      }
    },
    callweather() {
      this.active6 = !this.active6;
      this.handleWeather(this.active6);
      // this.$emit("messageWeather", this.active6);
      if (this.active6) {
        this.weatherEquipmentTag.map(v => {
          if (v && !v.isTooltipOpen()) {
            v.openTooltip();
          }
        });
        // this.airPort();
      } else {
        this.weatherEquipmentTag.map(v => {
          if (v && v.isTooltipOpen()) {
            v.closeTooltip();
          }
        });
        // this.daleteAirPort();
      }
    },
    callShowSign() {
      this.active2 = !this.active2;
      if (this.active2) {
        this.isSimplifyTooltip = true
        this.showSign();
      } else {
        this.deleteShowSign();
      }
      this.addMarker();
    },
    // 模拟用户点击折线绘制按钮
    enablePolylineDrawing() {
      this.showRange = !this.showRange;
      if (this.showRange) {
        var polylineButton = document.getElementsByClassName(
          "leaflet-draw-draw-polyline"
        )[0];
        if (polylineButton) {
          polylineButton.click();
        }
      } else {
        const cancelButton = document.querySelector(
          '.leaflet-draw-actions a[title="Cancel drawing"]'
        );
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    // 处理删除按钮点击事件
    handleDeleteDistance(layerToDelete, markerToDelete) {
      this.map.removeLayer(layerToDelete);
      this.map.removeLayer(markerToDelete._icon);
      this.map.removeLayer(markerToDelete);
      this.distanceLabels = this.distanceLabels.filter(
        item =>
          item.layer !== layerToDelete && item.label !== markerToDelete._icon
      );
    },
    addCircles() {
      this.isCircle = !this.isCircle;
      if (this.isCircle) {
        this.createCircles();
      } else {
        this.removeCircles();
      }
    },
    // 移除圆环
    removeCircles() {
      this.circles.forEach(circle => {
        this.map.removeLayer(circle);
      });
      this.circles = [];
      // 移除中心标记
      if (this.centerMarker) {
        this.map.removeLayer(this.centerMarker);
      }
      this.centerMarker = null;
    },
    // 创建圆环
    createCircles() {
      const center = this.map.getCenter();
      this.circles = [
        // 先画大圆，保证小圆在大圆的上层
        L.circle(center, {
          radius: 20000, // 半径20公里
          color: "#00FF00",
          weight: 2,
          opacity: 1,
          fillColor: "#00FF00",
          fillOpacity: 0.2
        }).addTo(this.map),
        L.circle(center, {
          radius: 10000, // 半径10公里
          color: "#FFFF00",
          weight: 2,
          opacity: 1,
          fillColor: "#FFFF00",
          fillOpacity: 0.2
        }).addTo(this.map),
        L.circle(center, {
          radius: 5000, // 半径5公里
          color: "#FF0000",
          weight: 2,
          opacity: 1,
          fillColor: "#FF0000",
          fillOpacity: 0.2
        }).addTo(this.map)
      ];
      // 在圆心添加中心标记
      const centerMarker = L.marker(center, {
        icon: L.divIcon({
          className: "center-marker",
          html:
            '<div class="cross"><div class="line1"></div><div class="line2"></div></div>'
        })
      });
      centerMarker.addTo(this.map);
      this.centerMarker = centerMarker;

      // 为每个圆添加鼠标悬停事件
      this.circles.forEach(circle => {
        let popup;
        const that = this;

        function togglePopup(latlng, showPopup) {
          if (showPopup) {
            popup = L.popup({
              closeButton: false // 设置closeButton为false来隐藏关闭按钮
            })
              .setLatLng(latlng)
              .setContent(
                `距离不足 ${that.getOriginalDistance(circle) / 1000} 公里`
              )
              .openOn(that.map);
          } else {
            popup.close();
          }
        }

        circle.on("mouseover", function (e) {
          togglePopup(e.latlng, true);
        });
        circle.on("mouseout", function (e) {
          togglePopup(e.latlng, false);
        });
      });
    },
    // 更新圆环的位置
    updateCirclesPosition() {
      const center = this.map.getCenter();
      this.circles.forEach(circle => {
        circle.setLatLng(center);
        const originalDistance = this.getOriginalDistance(circle);
        circle.setRadius(originalDistance);
      });
      // 更新中心标记位置
      if (this.centerMarker) {
        this.centerMarker.setLatLng(center);
      }
    },
    getOriginalDistance(circle) {
      // 根据颜色再设置对应圆的半径
      if (circle.options.color === "#FF0000") {
        return 5000;
      } else if (circle.options.color === "#FFFF00") {
        return 10000;
      } else if (circle.options.color === "#00FF00") {
        return 20000;
      }
      return 5000;
    },
    handleChildMessage(message) {
      // 更新父组件的数据
      this.active1 = message;
      this.uasId = null;
      if (message) {
        //绘制所有航迹
        this.addPolyAllline();
        // window.queryAllline = setInterval(this.addPolyAllline, 2000);
      } else {
        this.deletePolyAllline();
        clearInterval(window.queryAllline);
      }
    },
    //气象模式
    handleWeather(data) {
      this.showWeather = data;
      if(this.showWeather)
      this.getWeather();
    },
    getWeather() {
      //350500 南安  320100 南京 310000 上海 // 610100 西安
      this.getRequest(
        "/v3/weather/weatherInfo?city=310000&key=1d22a38b9f369f91704e4cd92fe5e35f"
      ).then(res => {
        let oData = res.data;
        if (oData.infocode == 10000) {
          this.weatherInfo = oData.lives[0];
          if (this.weatherInfo.weather.includes("晴")) {
            this.imgCondition.sunny = true;
          } else if (this.weatherInfo.weather.includes("雨")) {
            this.imgCondition.rain = true;
          } else if (this.weatherInfo.weather.includes("云")) {
            this.imgCondition.cloudy = true;
          } else {
            this.imgCondition.yin = true;
          }
        }
      });
    },
    //设置时间格式
    formatDate(weatherInfo) {
      const date = new Date(weatherInfo.reporttime);
      const year = date.getFullYear();
      const month = (1 + date.getMonth()).toString().padStart(2, "0");
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },
    changeMeteo(data) {
      this.meteoActive = data;
      if (data != 0) {
        if (data == 6) {
          this.switchLayer("wind");
        } else {
          this.switchLayer("hot");
        }
      }
    },
    clickRoad() {
      this.clickroad = !this.clickroad;
      if (this.clickroad) {
        this.clickstar = false;
        this.switchLayer("road");
      } else {
        this.switchLayer("back");
      }
      // this.handelShowLine()
      // this.handelShowAirSpace()
      // if (this.active2) {
      //   this.showSign();
      // }
      // if (this.active5) {
      //   this.airPort();
      // }
      // if (this.active6) {
      //   this.handleWeather(this.active6)
      // }
      // this.changeMonitorEquipment(true)
      // this.changeNavigationEquipment(true)
      // this.changeWeatherEquipment(true)
      // this.changeCountermeasureEquipment(true)
      // this.changeCommunicationEquipment(true)
      // this.changeADSBEquipment(true)
    },
    // 反制
    handelCounter() {
      if (this.showCounter) {
        this.postJsonRequest("/uav-task-server/countermeasureEquipment/trick", {
          longitude: 121.123123,
          latitude: 23.1231234,
          altitude: 123,
          height: 321
        }).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: res.data.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () { }
            });
          }
        });
      }
    },
    clickStar() {
      this.clickstar = !this.clickstar;
      if (this.clickstar) {
        this.clickroad = false;
        this.switchLayer("satellite");
      } else {
        this.switchLayer("back");
      }
      // this.handelShowLine()
      // this.handelShowAirSpace()
      // if (this.active2) {
      //   this.showSign();
      // }
      // if (this.active5) {
      //   this.airPort();
      // }
      // if (this.active6) {
      //   this.handleWeather(this.active6)
      // }
      // this.changeMonitorEquipment(true)
      // this.changeNavigationEquipment(true)
      // this.changeWeatherEquipment(true)
      // this.changeCountermeasureEquipment(true)
      // this.changeCommunicationEquipment(true)
      // this.changeADSBEquipment(true)
    },
    async changeCommunicationEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayCommunicationEquipment) {
          await this.getRequest(
            "/uav-task-server/communicationEquipment/queryAll"
          ).then(res => {
            this.equipmentTag("communication", res.data.data);
            // this.equipmentScope('communication', res.data.data)
          });
        }
        return;
      }
      this.isDisplayCommunicationEquipment = !this
        .isDisplayCommunicationEquipment;
      if (this.communicationEquipmentData.length > 0) {
        this.communicationEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.communicationEquipmentData = [];
        });
      }
      if (this.communicationEquipmentTag.length > 0) {
        this.communicationEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.communicationEquipmentTag = [];
        });
      }
      if (this.isDisplayCommunicationEquipment) {
        await this.getRequest(
          "/uav-task-server/communicationEquipment/queryAll"
        ).then(res => {
          this.equipmentTag("communication", res.data.data);
          // this.equipmentScope('communication', res.data.data)
        });
      }
    },
    async changeADSBEquipment(flag) {
      if (flag === true) {
        if (this.showADSB) {
          await this.getRequest(
            "/uav-task-server/surveillanceEquipment/queryAllByType?type=1"
          ).then(res => {
            this.equipmentTag("ADSB", res.data.data);
            this.equipmentScope("ADSB", res.data.data);
          });
        }
        return;
      }
      this.showADSB = !this.showADSB;
      if (this.ADSBEquipmentData.length > 0) {
        this.ADSBEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.ADSBEquipmentData = [];
        });
      }
      if (this.ADSBEquipmentTag.length > 0) {
        this.ADSBEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.ADSBEquipmentTag = [];
        });
      }
      if (this.showADSB) {
        await this.getRequest(
          "/uav-task-server/surveillanceEquipment/queryAllByType?type=1"
        ).then(res => {
          this.equipmentTag("ADSB", res.data.data);
          this.equipmentScope("ADSB", res.data.data);
        });
      }
    },
    async changeOneRadarEquipment(flag) {
      if (flag === true) {
        if (this.showOneRadar) {
          await this.getRequest(
            "/uav-task-server/surveillanceEquipment/queryAllByType?type=2"
          ).then(res => {
            this.equipmentTag("oneRadar", res.data.data);
            this.equipmentScope("oneRadar", res.data.data);
          });
        }
        return;
      }
      this.showOneRadar = !this.showOneRadar;
      if (this.oneRadarEquipmentData.length > 0) {
        this.oneRadarEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.oneRadarEquipmentData = [];
        });
      }
      if (this.oneRadarEquipmentTag.length > 0) {
        this.oneRadarEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.oneRadarEquipmentTag = [];
        });
      }
      if (this.showOneRadar) {
        await this.getRequest(
          "/uav-task-server/surveillanceEquipment/queryAllByType?type=2"
        ).then(res => {
          this.equipmentTag("oneRadar", res.data.data);
          this.equipmentScope("oneRadar", res.data.data);
        });
      }
    },
    async changeCountermeasureEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayCountermeasureEquipment) {
          await this.getRequest(
            "/uav-task-server/countermeasureEquipment/queryAll"
          ).then(res => {
            this.equipmentTag("countermeasure", res.data.data);
            this.equipmentScope("countermeasure", res.data.data);
          });
        }
        return;
      }
      this.isDisplayCountermeasureEquipment = !this
        .isDisplayCountermeasureEquipment;
      if (this.countermeasureEquipmentData.length > 0) {
        this.countermeasureEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.countermeasureEquipmentData = [];
        });
        this.countermeasurePopMakers.forEach(v => {
          this.map.removeLayer(v);
          this.countermeasurePopMakers = [];
        });
      }
      if (this.countermeasureEquipmentTag.length > 0) {
        this.countermeasureEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.countermeasureEquipmentTag = [];
        });
      }
      if (this.isDisplayCountermeasureEquipment) {
        await this.getRequest(
          "/uav-task-server/countermeasureEquipment/queryAll"
        ).then(res => {
          this.equipmentTag("countermeasure", res.data.data);
          this.equipmentScope("countermeasure", res.data.data);
        });
      }
    },
    async changeWeatherEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayWeatherEquipment) {
          await this.getRequest(
            "/uav-task-server/weatherEquipment/queryWeatherInfo"
          ).then(res => {
            this.equipmentTag("weather", res.data.data);
            this.equipmentScope("weather", res.data.data);
          });
        }
        return;
      }
      this.isDisplayWeatherEquipment = !this.isDisplayWeatherEquipment;
      if (this.weatherEquipmentData.length > 0) {
        this.weatherEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.weatherEquipmentData = [];
        });
      }
      if (this.weatherEquipmentTag.length > 0) {
        this.weatherEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.weatherEquipmentTag = [];
        });
      }
      if (this.isDisplayWeatherEquipment) {
        await this.getRequest(
          "/uav-task-server/weatherEquipment/queryWeatherInfo"
        ).then(res => {
          this.equipmentTag("weather", res.data.data);
          this.equipmentScope("weather", res.data.data);
        });
      }
    },
    async changeMonitorEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayMonitorEquipment) {
          await this.getRequest(
            "/uav-task-server/videoEquipment/queryAll"
          ).then(res => {
            this.equipmentTag("monitor", res.data.data);
            // this.equipmentScope('monitor', res.data.data)
          });
        }
        return;
      }
      this.isDisplayMonitorEquipment = !this.isDisplayMonitorEquipment;
      if (this.monitorEquipmentData.length > 0) {
        this.monitorEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.monitorEquipmentData = [];
        });
      }
      if (this.monitorEquipmentTag.length > 0) {
        this.monitorEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.monitorEquipmentTag = [];
        });
      }
      if (this.isDisplayMonitorEquipment) {
        await this.getRequest(
          "/uav-task-server/videoEquipment/queryAll"
        ).then(res => {
          this.equipmentTag("monitor", res.data.data);
          // this.equipmentScope('monitor', res.data.data)
        });
      }
    },
    async changeNavigationEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayNavigationEquipment) {
          await this.getRequest(
            "/uav-task-server/navigationEquipment/queryAll"
          ).then(res => {
            this.equipmentTag("navigation", res.data.data);
            this.equipmentScope("navigation", res.data.data);
          });
        }
        return;
      }
      this.isDisplayNavigationEquipment = !this.isDisplayNavigationEquipment;
      if (this.navigationEquipmentData.length > 0) {
        this.navigationEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.navigationEquipmentData = [];
        });
      }
      if (this.navigationEquipmentTag.length > 0) {
        this.navigationEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.navigationEquipmentTag = [];
        });
      }
      if (this.isDisplayNavigationEquipment) {
        await this.getRequest(
          "/uav-task-server/navigationEquipment/queryAll"
        ).then(res => {
          this.equipmentTag("navigation", res.data.data);
          this.equipmentScope("navigation", res.data.data);
        });
      }
    },
    async changeEnvelope() {
      this.isEnvelope = !this.isEnvelope;
      //清空原本marker重新添加marker
      if (this.markerPointData) {
        this.markerPointData.forEach(item => {
          this.map.removeLayer(item.markerPoint);
        });
        this.markerPointData = [];
      }
      await this.addMarker("envelope");
    },
    async changeTooltipBtn() {
      this.isSimplifyTooltip = !this.isSimplifyTooltip;
      if (!this.isSimplifyTooltip) {
        this.active2 = false
        this.showSign();
      } else {
        this.deleteShowSign();
      }
      this.addMarker();
    },
    switchLayer(layerType) {
      window.postMessage("changeLayerType", "*");
      // this.againPlaneWay();
      switch (layerType) {
        case "road":
          this.activeLayer = 1;
          // 移除现有图层并添加路网图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.roadUrlTemplate, {
            ltype: "11",
            attribution: "高德地图路网"
          }).addTo(this.map);
          break;
        case "satellite":
          this.activeLayer = 2;
          // 移除现有图层并添加卫星影像图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.satelliteUrlTemplate, {
            attribution: "高德地图卫星影像"
          }).addTo(this.map);
          break;
        case "hot":
          this.activeLayer = 3;
          // 定义热力点数量，加热力半径
          var heatNumbers = 150,
            heatRadius = 30;
          // 加热力坐标信息数组
          var heatPoints = [];
          // 遍历添加坐标信息
          for (var i = 0; i < heatNumbers; i++) {
            heatPoints[i] = [
              Math.random() * 0.28 + 39.78,
              Math.random() * 0.5 + 116.12,
              Math.random() * 80
            ];
          }
          if (this.heatLayer) {
            this.map.removeLayer(this.heatLayer);
          }
          if (this.velocityLayer) {
            this.map.removeLayer(this.velocityLayer);
          }
          // 调用渲染方法，传入半径，透明度参数，添加到地图
          this.heatLayer = L.heatLayer(heatPoints, {
            radius: heatRadius,
            minOpacity: 0.5
          }).addTo(this.map);

          break;
        case "wind":
          this.activeLayer = 3;
          var heatNumbers = 150,
            heatRadius = 30;
          // 加热力坐标信息数组
          var windData = [];
          // 遍历添加坐标信息
          for (var i = 0; i < heatNumbers; i++) {
            windData[i] = {
              lat: Math.random() * 0.28 + 39.78,
              lng: Math.random() * 0.5 + 116.12,
              angle: 45
            };
          }

          // 调用渲染方法，传入半径，透明度参数，添加到地图
          if (this.heatLayer) {
            this.map.removeLayer(this.heatLayer);
          }
          if (this.velocityLayer) {
            this.map.removeLayer(this.velocityLayer);
          }
          // 循环风向数据，绘制风向箭头
          var layer = windLayer(data);
          layer.addTo(this.map);

          break;
        // ... 同理添加其他图层
        case "back":
          this.activeLayer = 4;
          // 移除现有图层并添加路网图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.originLayer, {
            attribution: "高德原影像"
          }).addTo(this.map);
          break;
      }
    },
    //获取飞机速度高度曲线数据
    getChartData(uasId) {
      this.getRequest(
        `/uav-task-server/point/getGsAltitudeTimeCurve?uasID=${uasId}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.planeChartData = oData.data;
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
        }
      });
    },
    //获取飞机详细信息
    getPlaneDetailData(uasId, planNo) {
      this.getRequest(
        `/uav-task-server/plandto/getAircraftDetail?orderID=${planNo}&uavSerial=${uasId}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.planeDetailData = oData.data;
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
        }
      });
    },
    //定位用户地理位置
    getUserLocation() {
      let _this = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var lat = position.coords.latitude;
            var lon = position.coords.longitude;
            // 缩放级别 1: 整个世界
            // 缩放级别 5: 大洲
            // 缩放级别 10: 国家
            // 缩放级别 12: 大城市或州
            // 缩放级别 15: 城市或县
            // 缩放级别 17: 街道
            // 缩放级别 19: 建筑物
            let point = wgs84ToGcj02(lon, lat);
            _this.map.setView([point[1], point[0]], 10);
          },
          function (error) {
            // 错误回调
            // console.log("Chrome只允许HTTPS站点请求地理位置信息");
            console.error("Error finding location:", error);
          }
        );
      } else {
        // 浏览器不支持Geolocation
        alert("Your browser doesn't support geolocation.");
      }
    },
    //获取当前航点并定位
    getCurrentStatus() {
      this.getRequest("/uav-task-server/point/getLastPoint").then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data;
          if (records && records.length > 0) {
            //中心点重定位到首个航点
            let point = wgs84ToGcj02(records[0].longitude, records[0].latitude);
            this.map.setView([point[1], point[0]], 11);
          }
        }
      });
    },
    //监听最新航点以及航线变动，重新绘制航线
    againPlaneWay() {
      this.getRequest("/uav-task-server/point/getLastPoint").then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data;
          if (records && records.length > 0) {
            //中心点重定位到首个航点
            // this.map.setView([records[0].latitude, records[0].longitude], 12);
            //获取所有航道数据绘制航道

            if (this.runLineMarkers.length > 0) {
              this.runLineMarkers.forEach(marker => {
                this.map.removeLayer(marker);
              });
              this.runLineMarkers = [];
            }
            if (this.runLines.length > 0) {
              this.runLines.forEach(runLine => {
                this.map.removeLayer(runLine);
              });
              this.runLines = [];
            }
            if (this.runRoadWhites.length > 0) {
              this.runRoadWhites.forEach(runLine => {
                this.map.removeLayer(runLine);
              });
              this.runRoadWhites = [];
            }

            let runLineMarkers = [];
            records.forEach(item => {
              if (item.wplist) {
                let planepoints = [];
                item.wplist.forEach((po, index) => {
                  let point = wgs84ToGcj02(po.wplongitude, po.wplatitude);
                  planepoints.push([point[1], point[0]]);
                  //设置图标样式
                  let myIcon = L.icon({
                    iconUrl: `../../../static/${index == 0 || index == item.wplist.length - 1
                      ? "landPoint"
                      : "normalPoint"
                      }.png`,
                    iconSize:
                      index == 0 || index == item.wplist.length - 1
                        ? [45, 45]
                        : [20, 20]
                  });
                  let markerPoint = L.marker([point[1], point[0]], {
                    icon: myIcon
                  }).addTo(this.map);
                  markerPoint.bindTooltip(
                    `<span style="color:#000;font-weight:bold;">${po.name}</span>`,
                    {
                      //内容可以自定义为HTML，如：<div>自定义结构</div>
                      direction: "bottom", // 显示在底部
                      sticky: false,
                      offset: [0, 0] // 中心位置
                    }
                  );
                  markerPoint.setZIndexOffset(1000);
                  runLineMarkers.push(markerPoint);
                });

                this.planeWay(planepoints, [], item.routeType, "run");
              }
            });
            this.runLineMarkers = runLineMarkers;
          }
        }
      });
    },
    initWs(ws) {
      ws.addEventListener("close", () => {
        if (window.predictionTimer) {
          clearInterval(window.predictionTimer);
          window.predictionTimer = null;
        }
      });
      ws.addEventListener("message", e => {
        let data = JSON.parse(e.data);
        let realTask = []; //告警信息
        // console.log(data.content.filter(v=>(v.uavSerial=='1581F6Q8D24AB00GZF4W')),888)
        //type 1 飞机详情  type 2 天气预警 11更新航线 空域
        if (data.type == 1) {
          let records = data.content;
          // console.log(records, 'records')
          //如果没有飞机清空本地储存数据（飞机，航迹记录）
          if (!records.length) {
            this.markerPointData = [];
            // this.lineLength = {}
            // this.allLineLength = {}
            this.deletePolyAllline();
            this.planeChartData = [];
            this.planeDetailData = {};
          }
          if (records.filter(v => v.uasID == this.uasId).length) {
            this.wbsNum++;
            if (this.wbsNum % 2 !== 0) {
              //获取飞机高度速度
              this.getChartData(this.uasId);
            }
          }else {
            this.uasId = null
            this.clearSingleLine()
          }
          //筛选无人机数据
          if (!this.showADSB) {
            records = records.filter(v => v.uavType !== 3);
          }
          if (!this.isDisplayCountermeasureEquipment) {
            records = records.filter(v => v.uavType !== 4);
          }
          this.uasId
            ? (this.clickPlaneInfo = records.filter(
              v => v.uasID === this.uasId
            )[0])
            : "";
          // console.log(this.clickPlaneInfo,99)
          if (records && records.length > 0) {
            // console.log("拿到真实数据")
            // 拿到数据后清除预测点的定时器
            if (window.predictionTimer) {
              clearInterval(window.predictionTimer);
              window.predictionTimer = null;
            }
            let uavSerialsArray = records.map(item => ({
              id: item.uasID,
              uasID: item.uasID
            }));
            this.uavSerials = uavSerialsArray; //搜飞机的
            let infoArr = [];
            let orderID = [];
            records.forEach(po => {
              let info = {};
              info = {
                id: po.orderID,
                longtitude: po.longitude,
                latitude: po.latitude,
                altitude: po.altitude,
                planNo: po.orderID,
                uavSerial: po.uavSerial,
                modelName: po.uasModel,
                gs: po.gs,
                course: po.course,
                uasID: po.uasID,
                uavModel: po.uavModel,
                alarm: po.alarm,
                warning: po.warning,
                black: po.black,
                height: po.height,
                uavType: po.uavType,
                roll: po.roll,
                pit: po.pit,
                conflictsList: po.conflictsList,
                routeType: po.routeType
              };
              if (po.warning || po.alarm) {
                let warnMes = `${timestampToTime(
                  new Date(parseInt(po.timeStamp))
                )}${po.uasID}在${po.routeName}上发生偏航${po.warning ? "预警" : "告警"
                  }`;
                realTask.unshift({
                  warnMes: warnMes,
                  warning: po.warning,
                  alarm: po.alarm,
                  uasID: po.uasID
                });
              }
              if (po.black) {
                let warnMes = `${timestampToTime(
                  new Date(parseInt(po.timeStamp))
                )}${po.uasID}正在黑飞告警`;
                realTask.unshift({
                  warnMes: warnMes,
                  warning: 0,
                  alarm: 1,
                  uasID: po.uasID
                });
              }
              if (po.conflictsList && po.conflictsList.length) {
                //aow ture 告警 false 预警
                po.conflictsList.map(v => {
                  realTask.unshift({
                    warnMes: v.conflict,
                    warning: !v.aow,
                    uasID: po.uasID
                  });
                });
              }
              orderID.push(po.orderID);
              infoArr.push(info);
              // 把新接收点信息加入航迹点信息数组
              if (this.singleLine.length > 0 && po.uasID === this.uasId) {
                const lastPoint = this.singleLine[this.singleLine.length - 1];
                if (
                  lastPoint.longitude !== po.longitude ||
                  (lastPoint.latitude !== po.latitude &&
                    lastPoint.uasID === po.uasID &&
                    lastPoint.send == 0)
                ) {
                  this.singleLine.push({
                    ...po
                  });
                  // console.log('加入点', lastPoint.send,this.singleLine);
                } else {
                  // console.log('和最后一个点重复，不加入', this.singleLine)
                }
              }
            });
            this.oldOrderId = orderID;
            this.infoArr = infoArr;
            if (this.infoArr.length > 0) {
              // 画点画航迹
              this.addPointAndLine();
                if (this.singleLine.length > 0 && this.uasId && !this.active1) {
                  // console.log('前端拼接的航迹点集', new Date().getTime())
                  this.drawPolylineFromSingleLine();
                }
            }
          } else {
            this.uavSerials = [];
            // this.realTask = [];
            //清空航点
            if (this.markerPoints.length > 0) {
              this.markerPoints.forEach(marker => {
                this.map.removeLayer(marker);
              });
              this.markerPoints = [];
            }
            if (this.markerPointData.length > 0) {
              this.markerPointData.forEach(marker => {
                this.map.removeLayer(marker.markerPoint);
              });
              this.markerPointData = [];
            }
            //清除航线
            // if (this.polyline) {
            //   this.map.removeLayer(this.polyline);
            //   this.polyline = null;
            // }
            if (this.runlineWhites.length>0) {
              this.runlineWhites.forEach(item => {
                this.map.removeLayer(item);
              });
              this.runlineWhites = [];
            }
            if (this.trackLines.length > 0) {
              this.trackLines.forEach(item => {
                this.map.removeLayer(item);
              });
              this.trackLines = [];
            }
            //清除定位航线
            if (this.positionLines) {
              this.map.removeLayer(this.positionLines);
              this.positionLines = null;
            }
            if (this.positRoadWhite) {
              this.map.removeLayer(this.positRoadWhite);
              this.positRoadWhite = null;
            }
            if (this.airLinePositions.length > 0) {
              this.airLinePositions.forEach(airPort => {
                this.map.removeLayer(airPort);
              });
              this.airLinePositions = [];
              this.airLinePositions = [];
            }
            //清除正在飞行的航线以及航点
            if (this.runLineMarkers.length > 0) {
              this.runLineMarkers.forEach(airPort => {
                this.map.removeLayer(airPort);
              });
              this.runLineMarkers = [];
            }
            if (this.runLines.length > 0) {
              this.runLines.forEach(planline => {
                this.map.removeLayer(planline);
              });
              this.runLines = [];
            }
            if (this.runRoadWhites.length > 0) {
              this.runRoadWhites.forEach(runLine => {
                this.map.removeLayer(runLine);
              });
              this.runRoadWhites = [];
            }

            if (this.allPolyline.length > 0) {
              this.allPolyline.forEach(planline => {
                this.map.removeLayer(planline);
              });
              this.allPolyline = [];
            }
            if (this.allPolylines.length > 0) {
              this.allPolylines.forEach(planline => {
                this.map.removeLayer(planline);
              });
              this.allPolylines = [];
            }
          }
          // 获取到真实点后启动定时器进行预测
          if (this.infoArr && this.infoArr.length > 0) {
            // console.log('启动定时器预测',  new Date().getTime())
            //       window.predictionTimer = setInterval(this.predictPoint, 200);
          }
        } else if (data.type == 2) {
          let records = data.content;
          realTask.unshift({
            warnMes: records.content,
            warning: records.alarmType == 0 ? 1 : 0
          });
        } else if (data.type == 11) {
          this.airSpace();
        } else if (data.type == 12) {
          this.deletePlaneAllWay();
          this.planeAllWay();
        }
        this.realTask = realTask.concat(this.realTask);
        if (this.realTask.length > 10) {
          let num = this.realTask.length - 10;
          for (let i = 0; i < num; i++) {
            this.realTask.pop();
          }
        }
      });
    },
    getLastStatus() {
      this.getBounds(); //获取地图边界
      if (this.isBigScreen) {
        this.initWs(this.wsBigScreen)
      } else {
        this.initWs(this.ws)
      }
    },
    // 计算预测点
    // lat1: 起始纬度 lon1: 起始经度 speedMps:速度（米每秒） heading: 航向角（度） timeSec: 时间（秒）
    calculateNewPosition(lat1, lon1, speedMps, heading, timeSec) {
      const EARTH_RADIUS_M = 6371000; // 地球半径（米）
      const distanceM = speedMps * timeSec; // 计算距离（米）

      const headingRadians = this.toRadians(heading);
      const lat1Radians = this.toRadians(lat1);
      const lon1Radians = this.toRadians(lon1);
      const lat2 = Math.asin(
        Math.sin(lat1Radians) * Math.cos(distanceM / EARTH_RADIUS_M) +
        Math.cos(lat1Radians) *
        Math.sin(distanceM / EARTH_RADIUS_M) *
        Math.cos(headingRadians)
      );
      let lon2 =
        lon1Radians +
        Math.atan2(
          Math.sin(headingRadians) *
          Math.sin(distanceM / EARTH_RADIUS_M) *
          Math.cos(lat1Radians),
          Math.cos(distanceM / EARTH_RADIUS_M) -
          Math.sin(lat1Radians) * Math.sin(lat2)
        );
      const lat2Degrees = this.toDegrees(lat2);
      let lon2Degrees = this.toDegrees(lon2);
      lon2Degrees = ((lon2Degrees + 180) % 360) - 180;
      return [lat2Degrees, lon2Degrees];
    },
    toDegrees(radians) {
      return radians * (180 / Math.PI);
    },
    toRadians(degrees) {
      return degrees * (Math.PI / 180);
    },
    // 预测点
    predictPoint() {
      // console.log('预测中。。。',  new Date().getTime())
      let newInfoArr = [];
      this.infoArr.forEach(info => {
        //send：1-该点已经接受过；0-该点为新点
        if (info.gs > 0 && info.altitude > 50) {
          let point = this.calculateNewPosition(
            info.latitude,
            info.longtitude,
            info.gs,
            info.course,
            0.15
          );
          const predictionLat = point[0];
          const predictionLng = point[1];

          newInfoArr.push({
            ...info,
            latitude: predictionLat,
            longtitude: predictionLng,
            isPrediction: true
          });
          // console.log('预测点-->', point, new Date().getTime())
        } else {
          newInfoArr.push(info);
        }
      });
      this.infoArr = newInfoArr;
      // console.log('预测点集合newInfoArr', newInfoArr)
      // 画点画航迹
      this.addPointAndLine();
    },
    // 画点画航迹
    async addPointAndLine() {
      //绘制所有点
      this.addMarker();
      //绘制点之后画航迹
      if (this.active1) {
        this.addPolyAllline();
      }
    },
    queryPlan(v) {
      if (v) {
        this.planKeyWord = v;
      }
      this.getRequest(
        `/uav-task-server/plandto/queryPlanByConditionNoStatus?pagesize=100&keyWord=${this.planKeyWord}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data.list;
          if (records && records.length > 0) {
            this.taskList = records;
          } else {
            this.taskList = [];
          }
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
        }
      });
    },
    //画点
    addMarker(type) {
      if (this.markerPointData.length === 0) {
        this.infoArr.forEach(info => {
          this.createMarker(info, type);
        });
      } else {
        const oldUasIds = this.markerPointData.map(data => data.info.uasID);
        const newUasIds = this.infoArr.map(info => info.uasID);
        // 找出新增的 info
        const newInfos = this.infoArr.filter(
          info => !oldUasIds.includes(info.uasID)
        );
        // 找出相同的 info
        const sameInfos = this.infoArr.filter(info =>
          oldUasIds.includes(info.uasID)
        );
        // 找出多余的 info
        const redundantInfos = this.markerPointData.filter(
          data => !newUasIds.includes(data.info.uasID)
        );
        //保证动画先执行
        setTimeout(() => {
          redundantInfos.forEach(data => {
            this.map.removeLayer(data.markerPoint);
            const index = this.markerPoints.indexOf(data.markerPoint);
            if (index !== -1) {
              this.markerPoints.splice(index, 1);
              this.markerPointData.splice(index, 1);
            }
          });
        });
        // 为新增的 info 添加标记点
        newInfos.forEach(info => {
          this.createMarker(info, type);
        });

        function lerp(start, end, t) {
          return [
            start[1] + (end[1] - start[1]) * t, // 纬度
            start[0] + (end[0] - start[0]) * t // 经度
          ];
        }

        function animateMarker(marker, oldPoint, newPoint, duration) {
          let startTime = null;
          function animate(currentTime) {
            if (!startTime) startTime = currentTime;
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1); // 进度（0 到 1）
            // 计算当前点位置
            const currentPoint = lerp(oldPoint, newPoint, progress);
            marker.setLatLng(currentPoint);
            // 如果动画未完成，继续下一帧
            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          }

          requestAnimationFrame(animate);
        }

        // 让相同的 info 对应的标记点平滑移动
        sameInfos.forEach(info => {
          if (this.markerPointData.length) {
            const index = oldUasIds.indexOf(info.uasID);
            if (!this.markerPointData[index]) {
              return;
            }
            const markerPoint = this.markerPointData[index].markerPoint;
            const oldInfo = this.markerPointData[index].info;
            // 获取旧点和新点
            let oldPoint = wgs84ToGcj02(oldInfo.longtitude, oldInfo.latitude);
            let newPoint = wgs84ToGcj02(info.longtitude, info.latitude);
            // 调用动画函数
            animateMarker(markerPoint, oldPoint, newPoint, 2000); // 2 秒完成动画websocket2s传一次数据
            // 更新图标和提示信息
            let iconUrl = this.getIconUrl(info);
            let iconSize = this.typeMap[info.uavType];
            //设置图标样式
            let newIcon = L.divIcon({
              html: `<div id="planeMarker" class="planeMarker ${!this.isEnvelope ? "planeMarkerActive" : ""
                } "  ><img src=${iconUrl} alt=" " class="${this.typeMarkerSizeMap[info.uavType]
                }"></div>`,
              className: "planeMarker", // 添加我们定义的CSS类
              // iconSize: 40
              iconSize: [iconSize, iconSize],
              iconAnchor: [iconSize / 2, iconSize / 2]
            });
            let point = wgs84ToGcj02(info.longtitude, info.latitude);
            let rotateAngle = info.course; //航迹角 正北方向为0度，顺时针旋转
            markerPoint.setIcon(newIcon);
            markerPoint.setRotationAngle(rotateAngle);

            // 更新提示信息
            const planNoContent = info.planNo
              ? `<span>${info.planNo}</span>`
              : `<span>无计划</span>`;
            const alarmDiv = this.getAlarmDiv(info);
            const altitude =
              info.altitude != null
                ? Number(info.altitude).toFixed(2) + " m"
                : "/";
            const gs =
              info.gs != null ? Number(info.gs).toFixed(2) + " m/s" : "/";
            const height =
              info.height != null ? Number(info.height).toFixed(2) + " m" : "/";
            const course = info.course != null ? info.course + " °" : "/";
            const toolTip = this.isSimplifyTooltip
              ? `
              <div class="content">
                  <div class='tag' >
                      <div  style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">${info.uasID != null ? info.uasID : "/"
              }</div>
                      <div >${info.modelName || info.uavModel || "/"}</div>
                      <div>${altitude}</div>
                      <div>${gs}</div>
                  </div>
              </div>`
              : `
              <div class="content">
                  <div class="title" style="margin-left: 8px;overflow: hidden;width:200px;text-overflow: ellipsis;white-space: nowrap;">${info.uasID != null ? info.uasID : "/"
              }</div>
                  <div class='tag'>
                      <div >计划编号:${planNoContent}</div>
                      <div >飞机型号:${info.modelName ||
              info.uavModel ||
              "/"}</div>
                      <div >经度:<span>${info.longtitude != null
                ? this.decimalToDMS(info.longtitude)
                : "/"
              }</span></div>
                      <div >纬度:<span>${info.latitude != null
                ? this.decimalToDMS(info.latitude)
                : "/"
              }</span></div>
                      <div >海拔高:<span>${altitude}</span></div>
                      <div >真高:<span>${height}</span></div>
                      <div>速度:<span>${gs}</span></div>
                      <div >航迹角:<span>${course}</span></div>
                      ${alarmDiv}
                  </div>
              </div>`;

            markerPoint.bindTooltip(toolTip, {
              autoPan: false,
              zIndexOffset: 1100,
              direction: "bottom",
              permanent:
                this.tooltipPermanent || this.uasId === info.uasID,
              offset: [0, iconSize / 2],
              className: this.isSimplifyTooltip
                ? "simplifyTooltip"
                : "anim-tooltip"
            });

            const iconElement = markerPoint.getElement();
            if (info.alarm || info.warning || info.black) {
              iconElement && iconElement.classList.add("blinking");
            } else {
              iconElement && iconElement.classList.remove("blinking");
            }
            // 更新 markerPointData 中的 info
            this.markerPointData[index].info = info;
          }
        });
      }
    },
    //展示标牌
    showSign() {
      // 切换工具提示的 permanent 状态
      this.tooltipPermanent = true;
    },
    //绘制所有计划航道
    planeAllWay() {
      //分页查询所有航线，cairline/queryAllCAirline?currentpage=1&pagesize=100
      this.getRequest(
        "/uav-task-server/cairline/queryAllCAirline?pagesize=500&currentpage=1"
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let list = oData.data.list;
          if (list && list.length > 0) {
            if (this.planLines.length > 0) {
              this.planLines.forEach(planline => {
                this.map.removeLayer(planline);
              });
              this.planLines = [];
            }
            if (this.planlineWhite.length > 0) {
              this.planlineWhite.forEach(v => {
                this.map.removeLayer(v);
              });
              this.planlineWhite = [];
            }
            let disableIds = [];
            if (this.tableData.length) {
              disableIds = this.tableData
                .filter(v => v.isShowLine === false)
                .map(e => e.id);
              if (disableIds.length) {
                this.showlineall = false;
              } else {
                this.showlineall = true;
              }
            } else {
              this.tableData = list.map(v => ({
                name: v.name,
                // updatedAt: v.updatedAt.split(''),
                updatedAt: v.updatedAt,
                isShowLine: true,
                id: v.id
              }));
            }
            list.forEach(airLine => {
              if (disableIds.includes(airLine.id)) {
                return;
              }
              let airLineData = [];
              let points = [];
              airLine.airpointList.forEach(airpoint => {
                let point = wgs84ToGcj02(airpoint.longitude, airpoint.latitude);
                airLineData.push([point[1], point[0]]);
                points.push({
                  po: [point[1], point[0]],
                  name: airpoint.name,
                  altitude: airpoint.altitude,
                  type: airpoint.type
                });
              });
              this.planeWay(
                airLineData,
                points,
                airLine.airLineType,
                "plan",
                airLine.altitude,
                airLine.name,
                airLine.configdence?JSON.parse(airLine.configdence).weightedScore:''
              );
            });
          }
        } else {
          this.$message.error({
            message: "网络请求失败",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
        }
      });
    },
    //绘制航道
    planeWay(wayPoints, points, wayType, type, altitude, name,weightedScore) {
      const _this = this;
      // let weight = 8;
      // if (this.currentZoom < 10) {
      //   weight = 4;
      // } else if (this.currentZoom >= 10 && this.currentZoom <= 12) {
      //   weight = 8;
      // } else {
      //   weight = 12;
      // }
      // 0：观光 1：巡检 2：物流
      let waycolor =
        wayType == 1
          ? "#b5b500"
          : wayType == 0
            ? "#008000"
            : wayType == 2
              ? "#0000ff"
              : wayType == 3
                ? "#fd5939"
                : "#0000ff";
      // if (!wayType) {
      //   waycolor = "#0000ff";
      // }
      if (this.positionLines) {
        this.map.removeLayer(this.positionLines);
        this.positionLines = null;
      }
      if (this.positRoadWhite) {
        this.map.removeLayer(this.positRoadWhite);
        this.positRoadWhite = null;
      }

      //绘制航线上的斜线
      let planlineWhite = null;
      // 创建一个折线
      if (this.showDubuleLine) {
        planlineWhite = L.polyline(wayPoints, {
          smoothFactor: 1,
          color: "#fff", //航道底部颜色
          opacity: 0.8,
          weight: 9, //航道底部宽度
          lineCap: "butt",
          lineJoin: "round" // 线条连接处样式
        }).addTo(this.map);
      }

      function togglePopup(latlng, showPopup, map) {
        let popup;
        if (showPopup) {
          popup = L.popup({
            closeButton: false // 设置closeButton为false来隐藏关闭按钮
          })
            .setLatLng(latlng)
            .setContent(
              `<span style="color:#000;font-weight:bold;">${name}(${altitude}m)</span>`
            )
            .openOn(map);
        } else {
          popup && popup.close();
        }
      }

      // 添加 hover 事件监听器 航线移入移出
      // if (planlineWhite) {
      //   planlineWhite.on('mouseover', function (e) {
      //     //这里this指向map
      //     togglePopup(e.latlng, true, _this.map);
      //   });
      //   planlineWhite.on('mouseout', function (e) {
      //     togglePopup(e.latlng, false, _this.map, e);
      //   });
      // }

      let planline = L.polyline(wayPoints, {
        smoothFactor: 1,
        color: waycolor, //航道颜色
        opacity: 0.8,
        weight: this.showDubuleLine ? 5 : 2, //航道宽度
        lineCap: "butt",
        lineJoin: "round", // 线条拐角样式
        dashArray: this.showDubuleLine ? "10,2" : null, // 虚线，例如'10,10'表示10像素的实线和10像素的空白交替出现
        dashOffset: "1", // 虚线偏移量
        zIndex: 10 // 设置折线的 zIndex 属性
      }).addTo(this.map);

      planline.bindTooltip(name+ (weightedScore?`(${weightedScore})`:''), {
        autoPan: false,
        zIndexOffset: 1100,
        direction: "auto",
        permanent: this.showAirLineName ? true : false,
        className: "planlineName"
      });
      planline.on("mouseover", function (e) {
        //这里this指向map
        togglePopup(e.latlng, true, _this.map);
      });
      planline.on("mouseout", function (e) {
        togglePopup(e.latlng, false, _this.map, e);
      });
      if (planlineWhite) {
        planline.on("mouseover", function (e) {
          //这里this指向map
          togglePopup(e.latlng, true, _this.map);
        });
        planline.on("mouseout", function (e) {
          togglePopup(e.latlng, false, _this.map, e);
        });
      }
      this.drawAirLinePorts(points, type);
      if (type == "plan") {
        if (planlineWhite) {
          this.planlineWhite.push(planlineWhite);
        }
        this.planLines.push(planline);
      } else if (type == "run") {
        this.runLines.push(planline);
        if (planlineWhite) {
          this.runRoadWhites.push(planlineWhite);
        }
      } else if (type == "position") {
        this.positionLines = planline;
        if (planlineWhite) {
          this.positRoadWhite = planlineWhite;
        }
      }
    },
    //绘制航道上的航点
    drawAirLinePorts(pointData, type) {
      if (!this.showNormalairPort) {
        pointData = pointData.filter(v => v.type !== 0);
      }
      if (!this.showairPort) {
        pointData = pointData.filter(v => {
          return v.type !== 1 && v.type !== 2;
        });
      }
      if (this.airLinePositions.length > 0) {
        this.airLinePositions.forEach(marker => {
          this.map.removeLayer(marker);
        });
        this.airLinePositions = [];
      }
      if (pointData.length > 0) {
        pointData.forEach((item, index) => {
          //设置图标样式
          let myIcon = L.icon({
            iconUrl: `../../../static/${(this.showairPort &&
              (index === 0 || index === pointData.length - 1)) ||
              item.type === 1 ||
              item.type === 2
              ? "landPoint"
              : "normalPoint"
              }.png`,
            iconSize:
              (this.showairPort &&
                (index === 0 || index === pointData.length - 1)) ||
                item.type === 1 ||
                item.type === 2
                ? [45, 45]
                : [20, 20]
          });
          let markerPoint = L.marker(item.po, {
            icon: myIcon
          }).addTo(this.map);
          // 将 markerToTop 提升
          markerPoint.setZIndexOffset(1000);
          markerPoint.bindTooltip(
            `<span style="color:#000;font-weight:bold;">${item.name +
            "(" +
            item.altitude +
            "m)"}</span>`,
            {
              //内容可以自定义为HTML，如：<div>自定义结构</div>
              direction: "bottom", // 显示在底部
              sticky: false,
              offset: [0, 0], // 中心位置
              className: "isSimplifyTooltip11"
            }
          );
          if (type == "position") {
            this.airLinePositions.push(markerPoint);
          } else {
            this.airLinePorts.push(markerPoint);
          }
        });
        // this.airLinePorts = airLinePorts;
      }
    },
    //绘制航迹
    addPolyline(uasId) {
      this.getRequest("/uav-task-server/point/getTrack?uasID=" + uasId).then(
        res => {
          let data = res.data.data;
          // console.log('后端返回的航迹点集', data)
          // 把data作为singleLine数组的初始值
          this.singleLine = data;
          this.drawPolylineFromSingleLine(uasId);
        }
      );
    },
    drawPolylineFromSingleLine(uasId) {
      // // 清理之前的图层
      // if (this.trackLines.length > 0) {
      //   this.trackLines.forEach(item => {
      //     this.map.removeLayer(item);
      //   });
      //   this.trackLines = [];
      // }
      // if (this.runlineWhite) {
      //   this.map.removeLayer(this.runlineWhite);
      //   this.runlineWhite = null;
      // }
      // 每个航点的航迹点
      let points = [];
      let waycolor = "";
      if (this.singleLine.length > 0) {
        let routeType = this.singleLine[0].routeType;
        // 0：观光 1：巡检 2：物流 3：应急
        waycolor =
          routeType === 1
            ? "#b5b500"
            : routeType === 0
              ? "#008000"
              : routeType === 2
                ? "#0000ff"
                : routeType === 3
                  ? "#fd5939"
                  : "#0000ff";

        // if (!this.singleLine[0].routeType) {
        //   waycolor = "#0000ff";
        // }
        this.singleLine.forEach(item => {
          let point = wgs84ToGcj02(item.longitude, item.latitude);
          points.push([point[1], point[0]]);
        });
      }
      const firstPoints = points.slice(0,-1);
      const lang =this.singleLine[this.singleLine.length-1].longitude
      const lat = this.singleLine[this.singleLine.length-1].latitude
      let flag = false;
      if (Object.keys(Object.keys(this.lineLength).includes(uasId))) {
        if (JSON.stringify(this.lineLength[uasId]) === JSON.stringify([lang,lat])) {
          flag = true;
        } else {
          this.lineLength[uasId] = [lang,lat];
        }
      }
      // 绘制背景线条
      let runlineWhite = L.polyline(flag ? points : firstPoints, {
        smoothFactor: 1,
        color: "#fff",
        weight: 5,
        lineCap: "butt",
        lineJoin: "round"
      }).addTo(this.map);
      let trackLine = L.polyline(flag ? points : firstPoints, {
        smoothFactor: 1,
        color: waycolor, //#FF9C00橙色
        weight: 3,
        lineCap: "butt",
        lineJoin: "round" // 线条拐角样式
      }).addTo(this.map);
      // 最后一个点
      const lastPoint = points[points.length - 1];
      const totalTime = 2100; // 总时间 2 秒
      const steps = 10; // 分割成 10 个小步骤
      const interval = totalTime / steps;

      let currentStep = 0;
      const startPoint = firstPoints[firstPoints.length - 1];
      if (!startPoint) {
          return;
      }
      const deltaLat = (lastPoint[0] - startPoint[0]) / steps;
      const deltaLng = (lastPoint[1] - startPoint[1]) / steps;

      function drawNextStep() {
        if (currentStep < steps) {
          const newLat = startPoint[0] + deltaLat * (currentStep + 1);
          const newLng = startPoint[1] + deltaLng * (currentStep + 1);
          const newPoint = [newLat, newLng];
          const currentPoints = trackLine.getLatLngs();
          currentPoints.push(newPoint);
          trackLine.setLatLngs(currentPoints);
          runlineWhite.setLatLngs(currentPoints);
          currentStep++;
          setTimeout(drawNextStep, interval);
        }
      }

      // 开始绘制最后一个点
      !flag && drawNextStep();
      this.trackLines.push(trackLine);
      this.runlineWhites.push(runlineWhite);
    },
    clearSingleLine(){
      // this.$nextTick(()=>{
        if(this.trackLines.length){
          this.trackLines.forEach(item => {
            this.map.removeLayer(item);
          });
          this.trackLines = [];
        }
        if (this.runlineWhites.length>0) {
          this.runlineWhites.forEach(item => {
            this.map.removeLayer(item);
          });
          this.runlineWhites = [];
        }
      // })
    },
    //绘制所有航迹
    addPolyAllline() {
      this.getRequest("/uav-task-server/point/getAllTrack").then(res => {
        // if (this.allPolyline.length > 0 && res.data.data) {
        //   this.allPolyline.forEach(el => {
        //     this.map.removeLayer(el);
        //   });
        //   this.allPolyline = [];
        // }
        // if (this.allPolylines.length > 0 && res.data.data) {
        //   this.allPolylines.forEach(el => {
        //     this.map.removeLayer(el);
        //   });
        //   this.allPolylines = [];
        // }
        if(!res.data.data){
          console.log('数据掉包')
          return;
        }
        let data = res.data.data;
        //删除部分航迹
        Object.keys(data).map(uvaID => {
          this.allPolyline.forEach(el => {
            if(!el.options.id.includes(uvaID)){
              // delete this.allLineLength[uvaID];
              this.map.removeLayer(el);
            }
          });
          this.allPolylines.forEach(el => {
            if(!el.options.id.includes(uvaID)){
              this.map.removeLayer(el);
            }
          });
        })
        if (Object.keys(data).length) {
          //每个航点的航迹
          let waycolor = "";
          for (var key in data) {
            const lang = data[key][data[key].length - 1].longitude
            const lat = data[key][data[key].length - 1].latitude
            let flag = false;
            if (Object.keys(this.allLineLength).includes(key)) {
              //判断最后一个点于存储的老的最后一个点是否相同
              if (JSON.stringify(this.allLineLength[key]) === JSON.stringify([lang,lat])) {
                flag = true;
              } else {
                this.allLineLength[key] = [lang,lat];
              }
            } else {
              this.allLineLength[key] = [lang,lat];
            }
            let points = [];
            if (data[key].length > 0) {
              data[key].map(item => {
                let point = wgs84ToGcj02(item.longitude, item.latitude);
                points.push([point[1], point[0]]);
              });
            }
            let routeType = data[key][0].routeType;
            // 0：观光 1：巡检 2：物流
            waycolor =
              routeType == 1
                ? "#b5b500"
                : routeType == 0
                  ? "#008000"
                  : routeType == 2
                    ? "#0000ff"
                    : routeType == 3
                      ? "#fd5939"
                      : "#0000ff";
            if(points.length - 1 === 0){
              continue;
            }
            const firstPoints = points.slice(0, -1);
            if (this.active1) {
              let runlineWhite = L.polyline(flag?points:firstPoints, {
                smoothFactor: 1,
                color: "#fff", //航道颜色
                weight: 5, //航道宽度
                lineCap: "butt",
                lineJoin: "round" // 线条拐角样式
              }).addTo(this.map);
              runlineWhite.options.id = "runlineWhite"+key;
              let polyline = L.polyline(flag?points:firstPoints, {
                smoothFactor: 1,
                color: waycolor, //#FF9C00橙色
                weight: 3,
                lineCap: "butt",
                lineJoin: "round" // 线条拐角样式
              }).addTo(this.map);
              polyline.options.id = "myPolylineId"+key;
              // 最后一个点
              const lastPoint = points[points.length - 1];
              const totalTime = 2100; // 总时间 2 秒
              const steps = 10; // 分割成 10 个小步骤
              const interval = totalTime / steps;

              let currentStep = 0;
              const startPoint = firstPoints[firstPoints.length - 1];
              if (!startPoint) {
                continue;
              }
              const deltaLat = (lastPoint[0] - startPoint[0]) / steps;
              const deltaLng = (lastPoint[1] - startPoint[1]) / steps;
              function drawNextStep() {
                if (currentStep < steps) {
                  const newLat = startPoint[0] + deltaLat * (currentStep + 1);
                  const newLng = startPoint[1] + deltaLng * (currentStep + 1);
                  const newPoint = [newLat, newLng];
                  const currentPoints = polyline.getLatLngs();
                  currentPoints.push(newPoint);
                  polyline.setLatLngs(currentPoints);
                  runlineWhite.setLatLngs(currentPoints);
                  currentStep++;
                  setTimeout(drawNextStep, interval);
                }
              }

              // 开始绘制最后一个点
              !flag&&drawNextStep();
              this.allPolyline.push(polyline);
              this.allPolylines.push(runlineWhite);
            }
          }
          // this.allPolyline = allPolyline;
          // this.allPolylines = runlineWhites;
        }
      });
      // this.infoArr.forEach(item => {
      //   this.getRequest(
      //     "/uav-task-server/point/getTrack?uasID=" + item.uasID
      //   ).then(res => {
      //     let data = res.data.data;
      //     //每个航点的航迹点
      //     let points = [];
      //     if (data.length > 0) {
      //       data.forEach(item => {
      //         let point = wgs84ToGcj02(item.longitude, item.latitude);
      //         points.push([point[1], point[0]]);
      //       });
      //     }

      //     let polyline = L.polyline(points, {
      //       smoothFactor: 1,
      //       color: "green"
      //     }).addTo(this.map);
      //     allPolyline.push(polyline);
      //   });
      // });
      // this.allPolyline = allPolyline;
    },
    //删除所有航迹
    deletePolyAllline() {
      // if (this.polyline) {
      //   this.map.removeLayer(this.polyline);
      //   this.polyline = null;
      // }
      if (this.runlineWhite) {
        this.map.removeLayer(this.runlineWhite);
        this.runlineWhite = null;
      }
      if (this.allPolyline.length > 0) {
        this.allPolyline.forEach(item => {
          this.map.removeLayer(item);
        });
        this.allPolyline = [];
      }
      if (this.allPolylines.length > 0) {
        this.allPolylines.forEach(item => {
          this.map.removeLayer(item);
        });
        this.allPolylines = [];
      }
      if (this.trackLines.length > 0) {
        this.trackLines.forEach(item => {
          this.map.removeLayer(item);
        });
        this.trackLines = [];
      }
      this.allLineLength = {};
      this.lineLength = {};
      //单个
      // polyline: null, //单个航迹（当前点击的）
      // runlineWhite: null, //单个航迹白底
      //所有执行中
      // markerPoints: [], //所有实时更新的飞行器
      // runLineMarkers: [], //所有执行航线的（航点）
      // runLines: [], //所有执行中的航线
      // runlineWhites: [], //航线白底
      // allPolyline: [], //所有实时航迹
    },
    //绘制设备图标
    equipmentTag(type, data) {
      if (data.length > 0) {
        data.map(v => {
          //转换经纬度为纬经度
          let wgsPoint = null;
          if (type === "weather") {
            wgsPoint = wgs84ToGcj02(
              v.weatherEquipment.longitude,
              v.weatherEquipment.latitude
            );
          } else if (type === "monitor") {
            let offsetLongitude = -0.001;
            let offsetLatitude = 0;
            wgsPoint = wgs84ToGcj02(
              v.longitude + offsetLongitude,
              v.latitude + offsetLatitude
            );
          } else if (type === "ADSB") {
            let offsetLongitude = +0.001;
            let offsetLatitude = 0;
            wgsPoint = wgs84ToGcj02(
              v.longitude + offsetLongitude,
              v.latitude + offsetLatitude
            );
          } else {
            wgsPoint = wgs84ToGcj02(v.longitude, v.latitude);
          }
          let myIcon = L.icon({
            iconUrl: `../../../static/${type === "ADSB"
              ? "ADSB"
              : type === "communication"
                ? "tongxin_tag"
                : type === "countermeasure"
                  ? "fanzhi_tag"
                  : type === "weather"
                    ? "qixiang_tag"
                    : type === "monitor"
                      ? v.online === 1
                        ? "camera"
                        : "camera_offline"
                      : type === "navigation"
                        ? "daohang_tag"
                        : type === "oneRadar"
                          ? "oneRadar_tag"
                          : ""
              }.png`,
            iconSize: [50, 60]
          });
          let markerPoint = L.marker([wgsPoint[1], wgsPoint[0]], {
            icon: myIcon,
            zIndexOffset: 20000 // 设置层级偏移量
          }).addTo(this.map);
          if (type !== "weather") {
            markerPoint.bindTooltip(
              `<span style="color:#
            000;font-weight:bold;">${v.name}</span>`,
              {
                //内容可以自定义为HTML，如：<div>自定义结构</div>
                direction: "bottom", // 显示在底部
                sticky: false,
                offset: [0, 0] // 中心位置
              }
            );
            if (type === "countermeasure") {
              let isMarkerVisible = false; // 标记的显示状态
              let _this = this;
              markerPoint.on("click", function (event) {
                _this.countermeasureWorking = v.working;
                const deviceStatusText = v.online ? "" : "设备不在线";
                const imageUrl = v.working
                  ? "../../../static/fanzhi_tag_offline.png"
                  : "../../../static/fanzhi_icon.png";
                const markerDiv = L.divIcon({
                  className: "countermeasureMarker",
                  html: `
                        <div class="fanhziTitle">
                                     ${v.name}
                                     </div>
                        <div class="fenzhiWrap"  >
                        <div class="itemsWrap">
                        <div class="fanhziItem">
                            经度：${v.longitude
                      ? _this.decimalToDMS(v.longitude) + " E"
                      : "/"
                    }
                        </div>
                       <div class="fanhziItem">
                            纬度：${v.latitude
                      ? _this.decimalToDMS(v.latitude) + " N"
                      : "/"
                    }
                        </div>
                        <div class="fanhziItem">
                            高度：${v.altitude ? v.altitude.toFixed(2) : "/"}m
                        </div>
                        </div>
                        <div class="deviceStatusText">${deviceStatusText}</div>
                        <img alt="" class="fanhziICon" src="${imageUrl}"/>
                        </div>`,
                  iconSize: [278, 227],
                  iconAnchor: [139, 270]
                });
                if (!isMarkerVisible) {
                  // 添加新标记
                  let countermeasurePopMaker = L.marker(
                    [wgsPoint[1], wgsPoint[0]],
                    {
                      icon: markerDiv,
                      zIndexOffset: 2000 // 设置一个较高的z-index值
                    }
                  ).addTo(_this.map);
                  _this.countermeasurePopMakers.push(countermeasurePopMaker);
                  isMarkerVisible = true; // 更新标记状态
                  //图标点击事件
                  countermeasurePopMaker.on("click", e => {
                    // 获取图片元素
                    const imgElement = e.target._icon.querySelector(
                      ".fanhziICon"
                    );
                    if (v.online && imgElement) {
                      imgElement.addEventListener("click", imgEvent => {
                        imgEvent.stopPropagation(); // 阻止事件冒泡
                        if (!_this.countermeasureWorking) {
                          _this
                            .$confirm("确定开启一键反制", "提示", {
                              confirmButtonText: "确定",
                              cancelButtonText: "取消",
                              type: "warning"
                            })
                            .then(async () => {
                              await _this.handleConfirmCountermeasure(4, v.id);
                              if (_this.countermeasureWorking) {
                                let newMarkerDiv = L.divIcon({
                                  className: "countermeasureMarker",
                                  html: `
                             <div class="fanhziTitle">
                             ${v.name}
                          </div><div class="fenzhiWrap"  >

                          <div class="itemsWrap">
                          <div class="fanhziItem">
                            经度：${v.longitude
                                      ? _this.decimalToDMS(v.longitude) + " E"
                                      : "/"
                                    }
                        </div>
                       <div class="fanhziItem">
                            纬度：${v.latitude
                                      ? _this.decimalToDMS(v.latitude) + " N"
                                      : "/"
                                    }
                        </div>
                        <div class="fanhziItem">
                            高度：${v.altitude ? v.altitude.toFixed(2) : "/"}m
                        </div>
                          </div>
                          <img alt="" class="fanhziICon"  src="../../../static/fanzhi_tag_offline.png"/>
                          </div>`,
                                  iconSize: [278, 227],
                                  iconAnchor: [139, 270]
                                });
                                countermeasurePopMaker.setIcon(newMarkerDiv);
                              }
                            });
                        } else {
                          _this
                            .$confirm("确定关闭一键反制", "提示", {
                              confirmButtonText: "确定",
                              cancelButtonText: "取消",
                              type: "warning"
                            })
                            .then(async () => {
                              await _this.handleConfirmCountermeasure(1, v.id);
                              if (!_this.countermeasureWorking) {
                                let newMarkerDiv = L.divIcon({
                                  className: "countermeasureMarker",
                                  html: `
                             <div class="fanhziTitle">
                             ${v.name}
                          </div><div class="fenzhiWrap"  >

                          <div class="itemsWrap">
                          <div class="fanhziItem">
                            经度：${v.longitude
                                      ? _this.decimalToDMS(v.longitude) + " E"
                                      : "/"
                                    }
                        </div>
                       <div class="fanhziItem">
                            纬度：${v.latitude
                                      ? _this.decimalToDMS(v.latitude) + " N"
                                      : "/"
                                    }
                        </div>
                        <div class="fanhziItem">
                            高度：${v.altitude ? v.altitude.toFixed(2) : "/"}m
                        </div>
                          </div>
                          <img alt="" class="fanhziICon"  src="../../../static/fanzhi_icon.png"/>
                          </div>`,
                                  iconSize: [278, 227],
                                  iconAnchor: [139, 270]
                                });
                                countermeasurePopMaker.setIcon(newMarkerDiv);
                              }
                            });
                        }
                      });
                    }
                  });
                } else {
                  // 隐藏新标记
                  _this.countermeasurePopMakers.forEach(marker => {
                    _this.map.removeLayer(marker);
                  });
                  _this.countermeasurePopMakers = []; // 清空存储数组
                  isMarkerVisible = false; // 更新标记状态
                }
                // let countermeasurePopMaker = L.marker([wgsPoint[1], wgsPoint[0]], {
                //   icon: markerDiv,
                // }).addTo(_this.map);
                // this.countermeasurePopMakers.push(countermeasurePopMaker)
              });
            }
          }
          if (type === "monitor") {
            let _this = this;
            markerPoint.on("click", function (event) {
              if (v.videoUrl && v.online) {
                _this.videoName = v.name;
                _this.videoUrl = v.videoUrl;
                _this.isShowVideo = true;
                _this.startVideo();
              }
            });
          }
          // 图标根据地图放缩大小
          let _this = this;

          function getIconSize() {
            const zoomLevel = _this.map.getZoom();
            const size = (zoomLevel / 15) * 50; // 根据缩放级别调整大小
            return L.icon({
              iconUrl: `../../../static/${type === "ADSB"
                ? "ADSB"
                : type === "communication"
                  ? "tongxin_tag"
                  : type === "countermeasure"
                    ? "fanzhi_tag"
                    : type === "weather"
                      ? "qixiang_tag"
                      : type === "monitor"
                        ? v.online === 1
                          ? "camera"
                          : "camera_offline"
                        : type === "navigation"
                          ? "daohang_tag"
                          : type === "oneRadar"
                            ? "oneRadar_tag"
                            : ""
                }.png`,
              iconSize: [size, (size * 6) / 5]
            });
          }

          // 更新标记图标
          function updateMarker() {
            const newIcon = getIconSize();
            markerPoint.setIcon(newIcon);
          }

          updateMarker();
          // 监听地图缩放事件
          this.map.on("zoomend", updateMarker);
          if (type === "weather" && v.info) {
            markerPoint.bindTooltip(
              `<div class="weather" >
              <div class="top">
                <div class="address">
                  ${v.weatherEquipment.name}
                </div>
              </div>
              <div class="content">
                <div class="temperature">
                  ${v.info.temp}℃ &nbsp;

                </div>
                <div class="params">
                  <span>大气压强：${v.info.atm}kPa</span>
                </div>
                 <div class="params">
                  <span>降雨量：${v.info.precipitation}mm</span>&nbsp;&nbsp;
                  <span>噪音：${v.info.noise}dB</span>
                </div >
                <div class="bottom params"  style="display: flex;justify-content: space-between">
                  <span>风速：${v.info.windspeed}</span>
                  <span>风向：${v.info.windDirection}</span>
                  <span>湿度：${v.info.hum}</span>
                </div>
              </div>
            </div>`,
              {
                //内容可以自定义为HTML，如：<div>自定义结构</div>
                direction: "bottom", // 显示在底部
                sticky: false,
                className: "weather-toolTip",
                permanent: true,
                offset: [0, 35] // 中心位置
              }
            );
            markerPoint.on("click", e => {
              if (!markerPoint.isTooltipOpen()) {
                markerPoint.openTooltip();
              } else {
                markerPoint.closeTooltip();
              }
            });
          }
          switch (type) {
            case "communication":
              this.communicationEquipmentTag.push(markerPoint);
              break;
            case "monitor":
              this.monitorEquipmentTag.push(markerPoint);
              break;
            case "navigation":
              this.navigationEquipmentTag.push(markerPoint);
              break;
            case "weather":
              this.weatherEquipmentTag.push(markerPoint);
              break;
            case "countermeasure":
              this.countermeasureEquipmentTag.push(markerPoint);
              break;
            case "ADSB":
              this.ADSBEquipmentTag.push(markerPoint);
              break;
            case "oneRadar":
              this.oneRadarEquipmentTag.push(markerPoint);
              break;
          }
        });
      }
    },
    //绘制设备作用范围
    equipmentScope(type, data) {
      if (data.length > 0) {
        //通信设备
        let svgGradient = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:rgb(0,231,163); stop-opacity:0" />
                    <stop offset="100%" style="stop-color:rgb(0,231,163);stop-opacity:0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //气象设备
        let svgGradient1 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad1" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:rgb(0,255,252); stop-opacity:0" />
                    <stop offset="100%" style="stop-color:rgb(0,255,252);stop-opacity:0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //侦测设备
        let svgGradient21 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad21" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:green; stop-opacity:0" />
                    <stop offset="100%" style="stop-color:green;stop-opacity::0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //
        let svgGradient22 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad22" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:red; stop-opacity:0" />
                    <stop offset="100%" style="stop-color:red;stop-opacity::0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //ADSB设备 一次雷达
        let svgGradient3 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad3" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:rgb(255,177,27); stop-opacity:0" />
                    <stop offset="100%" style="stop-color:rgb(255,177,27);stop-opacity::0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //导航设备
        let svgGradient4 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad4" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:rgb(0,177,251); stop-opacity:0" />
                    <stop offset="100%" style="stop-color:rgb(0,177,251);stop-opacity::0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        // 将 SVG 渐变添加到文档
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient1);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient21);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient22);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient3);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient4);
        if (type !== "countermeasure") {
          data.map(v => {
            //转换经纬度为纬经度
            let wgsPoint = null;
            if (type === "weather") {
              wgsPoint = wgs84ToGcj02(
                v.weatherEquipment.longitude,
                v.weatherEquipment.latitude
              );
            } else if (type === "monitor") {
              let offsetLongitude = -0.002;
              let offsetLatitude = 0;
              wgsPoint = wgs84ToGcj02(
                v.longitude + offsetLongitude,
                v.latitude + offsetLatitude
              );
            } else {
              wgsPoint = wgs84ToGcj02(v.longitude, v.latitude);
            }
            let polygon = L.circle([wgsPoint[1], wgsPoint[0]], {
              radius:
                type === "weather" ? v.weatherEquipment.distance : v.distance, // 设置圆的半径
              color:
                type === "ADSB" || type === "oneRadar"
                  ? "rgb(248,151,25)"
                  : type === "communication"
                    ? "rgb(0,231,163)"
                    : type === "weather"
                      ? "rgb(2,232,232)"
                      : type === "navigation"
                        ? "rgb(2,168,230)"
                        : "", // 设置圆的边框颜色
              fillColor:
                type === "ADSB" || type === "oneRadar"
                  ? "url(#grad3)"
                  : type === "communication"
                    ? "url(#grad)"
                    : type === "weather"
                      ? "url(#grad1)"
                      : type === "navigation"
                        ? "url(#grad4)"
                        : "", // 设置圆的填充颜色
              fillOpacity: 1, // 设置圆的填充透明度
              weight: 2 //边框宽度
            }).addTo(this.map);
            switch (type) {
              case "communication":
                this.communicationEquipmentData.push(polygon);
                break;
              case "monitor":
                this.monitorEquipmentData.push(polygon);
                break;
              case "navigation":
                this.navigationEquipmentData.push(polygon);
                break;
              case "weather":
                this.weatherEquipmentData.push(polygon);
                break;
              case "ADSB":
                this.ADSBEquipmentData.push(polygon);
                break;
              case "oneRadar":
                this.oneRadarEquipmentData.push(polygon);
                break;
            }
          });
        } else {
          data.map(v => {
            //转换经纬度为纬经度
            let wgsPoint = wgs84ToGcj02(v.longitude, v.latitude);
            let polygon = L.circle([wgsPoint[1], wgsPoint[0]], {
              radius: v.operatingDistance, // 设置圆的半径
              color: "green", // 设置圆的边框颜色
              fillColor: "url(#grad21)", // 设置圆的填充颜色
              fillOpacity: 1, // 设置圆的填充透明度
              weight: 2 //边框宽度
            }).addTo(this.map);
            polygon.bindTooltip(
              `<span style="color:#
                    000;font-weight:bold;">${v.name}</span>`,
              {
                //内容可以自定义为HTML，如：<div>自定义结构</div>
                direction: "bottom", // 显示在底部
                sticky: false,
                offset: [0, 0] // 中心位置
              }
            );
            let polygon1 = L.circle([wgsPoint[1], wgsPoint[0]], {
              radius: v.detectionDistance, // 设置圆的半径
              color: "red", // 设置圆的边框颜色
              fillColor: "url(#grad22)", // 设置圆的填充颜色
              fillOpacity: 1, // 设置圆的填充透明度
              weight: 2 //边框宽度
            }).addTo(this.map);
            polygon1.bindTooltip(
              `<span style="color:#
                    000;font-weight:bold;">${v.name}</span>`,
              {
                //内容可以自定义为HTML，如：<div>自定义结构</div>
                direction: "bottom", // 显示在底部
                sticky: false,
                offset: [0, 0] // 中心位置
              }
            );
            this.countermeasureEquipmentData.push(polygon);
            this.countermeasureEquipmentData.push(polygon1);
          });
        }
      }
    },
    //绘制空域
    airSpace() {
      this.getRequest(
        `/uav-task-server/airspace/queryAirspace?cateType=10&cateType=20&cateType=30`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let res = JSON.parse(oData.data);
          let features = res.features;
          //绘制前清除空域
          if (this.airSpaces.length > 0) {
            this.airSpaces.forEach(item => {
              this.map.removeLayer(item);
            });
            this.airSpaces = [];
          }
          //设置颜色分类
          if (features.length > 0) {
            //0 禁飞区（红色） 1 电子围栏（有个属性控制，在电子围栏内是否可飞，红色） 2. 3.适飞区(绿色) 4. 限飞区(黄色)  0-9 报告空域(大类)
            //11-19   11-管制空域(大类) //橙色
            //21-29   21-监视空域(大类) //黄色
            let airSpaces = [];
            let disableIds = [];
            if (this.airSpaceTableData.length) {
              disableIds = this.airSpaceTableData
                .filter(v => v.isShowAirSpace === false)
                .map(e => e.id);
              if (disableIds.length) {
                this.showAirspaceAll = false;
              } else {
                this.showAirspaceAll = true;
              }
            } else {
              this.airSpaceTableData = features.map(v => ({
                airspaceName: v.properties.airspaceName,
                COLOR:
                  v.properties.COLOR === "red"
                    ? "红色"
                    : v.properties.COLOR === "green"
                      ? "绿色"
                      : v.properties.COLOR === "yellow"
                        ? "黄色"
                        : v.properties.COLOR === "orange"
                          ? "橙色"
                          : v.properties.COLOR,
                TYPE: v.properties.TYPE,
                STARTTIME: v.properties.STARTTIME.slice(0, 10),
                ENDTIME: v.properties.ENDTIME.slice(0, 10),
                isShowAirSpace: true,
                id: v.properties.id
              }));
            }
            features.forEach(space => {
              if (disableIds.includes(space.properties.id)) {
                return;
              }

              let shapeType = space.properties.SHAPETYPE;
              //遍历该类型下的所有空域多边形
              space.geometry.coordinates.forEach(coordinate => {
                if (disableIds.includes(coordinate.id)) {
                  return;
                }
                //转换经纬度为纬经度
                let changedCoord = [];
                coordinate[0].forEach(point => {
                  let wgsPoint = wgs84ToGcj02(point[0], point[1]);
                  changedCoord.push([wgsPoint[1], wgsPoint[0]]);
                });
                let svgGradient1 = `
                       <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                  <defs>
                      <radialGradient id="redSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           <stop offset="80%" style="stop-color:#ff5555; stop-opacity:0" />
                            <stop offset="100%" style="stop-color:#ff5555;stop-opacity:1" />
                      </radialGradient>
                  </defs>
                       </svg>`;
                let svgGradient2 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="greenSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                             <stop offset="80%" style="stop-color:#0fd077; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:#0fd077;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                let svgGradient3 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="yellowSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           <stop offset="80%" style="stop-color:#ffc877; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:#ffc877;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                let svgGradient4 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="graySpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           stop offset="80%" style="stop-color:gray; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:gray;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                let svgGradient5 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="orangeSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           stop offset="80%" style="stop-color:orange; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:orange;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;

                // 将 SVG 渐变添加到文档
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient1);
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient2);
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient3);
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient4);
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient5);
                let polygon = null;
                if (shapeType == 0) {
                  //绘制多边形
                  polygon = L.polygon(changedCoord, {
                    color:
                      this.allEyesModel ? 'rgba(214,211,241,0.48)' : space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? "#e21838"
                        : space.properties.TYPE === 3
                          ? "#21f48e"
                          : space.properties.TYPE === 4 ||
                            space.properties.TYPE === 21
                            ? "yellow"
                            : space.properties.TYPE === 11
                              ? "orange"
                              : null, //填充颜色, //边框颜色#aa0000
                    fillColor:
                      this.allEyesModel ? 'rgba(214,211,241,0.48)' : space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? "rgba(226,24,56,0.48)"
                        : space.properties.TYPE === 3
                          ? "rgba(32,180,67,0.48)"
                          : space.properties.TYPE === 4 ||
                            space.properties.TYPE === 21
                            ? "rgba(252,255,44,0.48)"
                            : space.properties.TYPE === 11
                              ? "rgba(248,168,34,0.48)"
                              : null, //填充颜色
                    fillOpacity: 1, //填充透明度
                    weight: 1 //边框宽度
                  }).addTo(this.map);
                  polygon.spaceType = space.properties.TYPE;
                } else {
                  polygon = L.circle(changedCoord[0], {
                    radius: space.properties.RADIUS, // 设置圆的半径
                    // color: "rgba(0,0,0,0.5)", // 设置圆的边框颜色
                    // fillColor: space.properties.TYPE === 0 || space.properties.TYPE === 1
                    //   ? 'url(#redSpace)'
                    //   : space.properties.TYPE === 3
                    //     ? 'url(#greenSpace)'
                    //     : space.properties.TYPE === 4 || space.properties.TYPE === 21
                    //       ? 'url(#yellowSpace)'
                    //       : space.properties.TYPE === 11
                    //         ? 'url(#orangeSpace)'
                    //         : null, //填充颜色
                    // fillOpacity: 0.88, // 设置圆的填充透明度
                    color:
                      this.allEyesModel ? 'rgba(214,211,241,0.48)' : space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? "#e21838"
                        : space.properties.TYPE === 3
                          ? "#21f48e"
                          : space.properties.TYPE === 4 ||
                            space.properties.TYPE === 21
                            ? "yellow"
                            : space.properties.TYPE === 11
                              ? "orange"
                              : null, //填充颜色, //边框颜色#aa0000
                    fillColor:
                      this.allEyesModel ? 'rgba(214,211,241,0.48)' : space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? "rgba(226,24,56,0.48)"
                        : space.properties.TYPE === 3
                          ? "rgba(32,180,67,0.48)"
                          : space.properties.TYPE === 4 ||
                            space.properties.TYPE === 21
                            ? "rgba(252,255,44,0.48)"
                            : space.properties.TYPE === 11
                              ? "rgba(248,168,34,0.48)"
                              : null, //填充颜色
                    fillOpacity: 1, //填充透明度
                    weight: 1 //边框宽度
                  }).addTo(this.map);
                  polygon.spaceType = space.properties.TYPE;
                }
                let _this = this;
                // 添加 hover 事件监听器 移入移出
                if (polygon) {
                  let popup;
                  function togglePopup(latlng, showPopup, map) {
                    if (showPopup) {
                      popup = L.popup({
                        closeButton: false // 设置closeButton为false来隐藏关闭按钮
                      })
                        .setLatLng(latlng)
                        .setContent(
                          `
                            <div style="color:#000;font-weight:bold;text-align: center;font-size: 14px">${space.properties.airspaceName
                          }(${space.properties.BOTTOM_HEIHGT}~${space
                            .properties.HEIGHT +
                          space.properties.BOTTOM_HEIHGT}m)</div>
                           <div>${space.properties.STARTTIME} ~ ${space.properties.ENDTIME
                          } </div>
                          `
                        )
                        .openOn(map);
                    } else {
                      popup && popup.close();
                    }
                  }
                  polygon.on("mouseover", function (e) {
                    //这里this指向map
                    togglePopup(e.latlng, true, _this.map);
                  });
                  polygon.on("mouseout", function (e) {
                    togglePopup(e.latlng, false, _this.map, e);
                  });
                }

                airSpaces.push(polygon);
              });
            });
            this.airSpaces = airSpaces;
          }
          //将航线 移动到最顶层
          if (this.planlineWhite.length > 0) {
            this.planlineWhite.forEach(planline => {
              planline.removeFrom(this.map);
              planline.addTo(this.map);
            });
          }
          if (this.planLines.length > 0) {
            this.planLines.forEach(planline => {
              planline.removeFrom(this.map);
              planline.addTo(this.map);
            });
          }
        } else {
          console.log(oData.msg);
        }
      });
    },
    //绘制起降点
    airPort() {
      this.getRequest(
        "/uav-task-server/cpoint/queryAllCPoint?pagesize=700&currentpage=1"
      ).then(res => {
        let oData = res.data;
        if (0 == oData.code) {
          let pointDataList = oData.data.list;
          this.drawAirPorts(pointDataList);
        }
      });
    },
    drawAirPorts(pointDataList) {
      let airPorts = [];
      pointDataList.forEach(item => {
        //设置图标样式
        let myIcon = L.icon({
          iconUrl: `../../../static/${item.type == 0
            ? "normalPoint"
            : item.type == 1
              ? "landPoint"
              : "landPoint"
            }.png`,
          iconSize: item.type == 0 ? [20, 20] : [45, 45]
        });
        let center = wgs84ToGcj02(item.longitude, item.latitude);
        let markerPoint = L.marker([center[1], center[0]], {
          icon: myIcon
        });
        // .addTo(this.map);
        markerPoint.bindTooltip(
          `<span style="color:#
            000;font-weight:bold;">${item.name}</span>`,
          {
            //内容可以自定义为HTML，如：<div>自定义结构</div>
            direction: "bottom", // 显示在底部
            sticky: false,
            offset: [0, 0] // 中心位置
          }
        );
        airPorts.push(markerPoint);
      });
      this.airPorts = airPorts;
      // 创建聚合标记组
      this.markers = L.markerClusterGroup({
        maxClusterRadius: 10, //设置最大聚类半径
        spiderfyOnMaxZoom: true
      });
      // 添加聚合标记
      this.markers.addLayers(this.airPorts); //一次性聚合所有航点
      this.map.addLayer(this.markers);
    },
    //删除功能面板已有数据
    //清空标牌
    deleteShowSign() {
      this.tooltipPermanent = false;
      this.uasId = null;
    },
    //清空所有计划航道
    deletePlaneAllWay() {
      if (this.planLines.length > 0) {
        this.planLines.forEach(planline => {
          this.map.removeLayer(planline);
        });
        this.planLines = [];
      }
      if (this.planlineWhite.length > 0) {
        this.planlineWhite.forEach(planline => {
          this.map.removeLayer(planline);
        });
        this.planlineWhite = [];
      }

      if (this.airLinePorts.length > 0) {
        this.airLinePorts.forEach(point => {
          this.map.removeLayer(point);
        });
        this.airLinePorts = [];
      }
    },
    //清空所有空域
    daleteAirSpace() {
      if (this.airSpaces.length > 0) {
        this.airSpaces.forEach(airSpace => {
          this.map.removeLayer(airSpace);
        });
        this.airSpaces = [];
      }
    },
    //清空所有机场
    daleteAirPort() {
      if (this.airPorts.length > 0) {
        this.airPorts.forEach(airPort => {
          this.map.removeLayer(airPort);
        });
        this.airPorts = [];
        this.markers.clearLayers(); //清空聚合标记
      }
      // if (this.runLineMarkers.length > 0) {
      //   this.runLineMarkers.forEach(airPort => {
      //     this.map.removeLayer(airPort);
      //   });
      // }
    },
    //更新航道线宽样式
    updatePolylineWeight() {
      let weight = 10;
      if (this.currentZoom <= 12) {
        weight = 8;
      } else {
        weight = 12;
      }
      if (this.planLines.length > 0) {
        this.planLines.forEach(planline => {
          planline.setStyle({
            weight: weight
          });
        });
      }
      if (this.planlineWhite.length > 0) {
        this.planlineWhite.forEach(planline => {
          planline.setStyle({
            weight: weight + 4
          });
        });
      }
      if (this.runLines.length > 0) {
        this.runLines.forEach(planline => {
          planline.setStyle({
            weight: weight
          });
        });
      }
    },
    //定位飞机或航线
    positionPoint(point) {
      let newpoint = wgs84ToGcj02(point.longitude, point.latitude);
      this.map.setView([newpoint[1], newpoint[0]], 16);
    },
    // 绘制风向箭头的函数
    windLayer(data) {
      var velocityLayer = L.velocityLayer({
        displayValues: true,
        displayOptions: {
          velocityType: "GBR Wind",
          displayPosition: "bottomleft",
          displayEmptyString: "No wind data"
        },
        data: data,
        minVelocity: 0, //Velocity：速率
        maxVelocity: 10,
        velocityScale: 0.005,
        particleMultiplier: 1 / 300, //粒子的数量
        lineWidth: 2, //粒子的粗细
        frameRate: 15, //定义每秒执行的次数
        colorScale: [
          "rgb(255,255,255)",
          "rgb(255,255,255)",
          "rgb(255,255,255)",
          "rgb(255,255,255)",
          "rgb(255,255,255)"
        ]
      });
      return velocityLayer;
    },
    // //创建椭圆包络
    // createRotatedEllipse(center, semiMajorAxis, semiMinorAxis, rotation) {
    //   const ellipse = L.Polygon([], { color: 'blue', fillColor: 'lightblue', fillOpacity: 0.5 });
    //   const points = [];
    //
    //   for (let i = 0; i <= 360; i++) {
    //     const angle = i * (Math.PI / 180);
    //
    //     // 椭圆的点计算
    //     const x = semiMajorAxis * Math.cos(angle);
    //     const y = semiMinorAxis * Math.sin(angle);
    //
    //     // 旋转矩阵
    //     const rotatedX = x * Math.cos(rotation) - y * Math.sin(rotation);
    //     const rotatedY = x * Math.sin(rotation) + y * Math.cos(rotation);
    //
    //     // 经纬度计算
    //     const lat = center[0] + (rotatedY / 111320); // 纬度变化
    //     const lng = center[1] + (rotatedX / (111320 * Math.cos(center[0] * (Math.PI / 180)))); // 经度变化
    //
    //     points.push([lat, lng]);
    //   }
    //
    //   ellipse.setLatLngs(points);
    //   return ellipse;
    // },

    //经纬度转度分秒
    decimalToDMS(decimal) {
      const degrees = Math.floor(decimal);
      const minutes = Math.floor((decimal - degrees) * 60);
      const seconds = Math.floor(
        Math.round((decimal - degrees - minutes / 60) * 3600 * 1000) / 1000
      ); // 保留千分位
      return `${degrees}° ${minutes}' ${seconds}"`;
    },
    // 打开飞机搜索框
    openSearch() {
      this.searchForm.uasID = ""; // 清空搜索框
      this.searchFormVisible = true;
    },
    handleSearch() {
      console.log("搜索内容：", this.searchForm.uasID);
      if (this.infoArr.length > 0) {
        var foundObject = this.infoArr.find(item => {
          // 根据uavSerial查找匹配飞机
          return item.uasID === this.searchForm.uasID;
        });
        if (foundObject) {
          let point = {
            longitude: foundObject.longtitude,
            latitude: foundObject.latitude
          };
          this.positionPoint(point);
        }
      }
      this.searchFormVisible = false;
    },
    // 生成随机字符串
    generateRandomString(length = 10) {
      const characters =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      return result;
    },
    // 获取地图边界
    getBounds() {
      let bounds = this.map.getBounds(); // 获取地图边界
      let southWest = bounds.getSouthWest(); // 获取边界的西南角
      let northEast = bounds.getNorthEast(); // 获取边界的东北角
      let point1 = gcj02ToWgs84(southWest.lng, southWest.lat); // 左下的点
      let point2 = gcj02ToWgs84(northEast.lng, northEast.lat); // 右上的点
      this.southWestLat = point1[1];
      this.southWestLng = point1[0];
      this.northEastLat = point2[1];
      this.northEastLng = point2[0];
    },
    // 发送边界数据
    sendBounds() {
      let data = {
        southWestLat: this.southWestLat,
        southWestLng: this.southWestLng,
        northEastLat: this.northEastLat,
        northEastLng: this.northEastLng
      };
      this.ws.send(JSON.stringify(data));
    },
    // 搜索计划
    searchItem(val) {
      this.queryPlan(val);
    }
  },
  destroyed() {
    if (window.queryTaskTimer) {
      clearInterval(window.queryTaskTimer);
      window.queryTaskTimer = null;
    }
    if (window.predictionTimer) {
      clearInterval(window.predictionTimer);
      window.predictionTimer = null;
    }
  },
  watch: {
    ws: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getLastStatus()
        }
      }
    },
    //监听orderID变动则更新航道
    oldOrderId: {
      handler(newVal, oldVal) {
        const arraysAreEqual =
          newVal.length === oldVal.length &&
          newVal.every((value, index) => value === oldVal[index]);
        if (!arraysAreEqual) {
          //此处后端有bug，需下一个接口能拿到航线数据
          // this.againPlaneWay();
          // setTimeout(() => {
          //   this.againPlaneWay();
          // }, 2000);
        }
      }
    },
    tooltipPermanent: {
      handler(newVal, oldVal) {
        this.updateTooltip = true;
      }
    },
    infoArr: {
      handler(newVal, oldVal) {
        //监听第一次获得航点数据，
        // if (oldVal.length == 0 && newVal.length > 0) {
        //   this.getCurrentStatus();
        // }
        //监听上次航点有数据，本次无数据则停止调用获取航点接口
        if (oldVal.length > 0 && newVal.length == 0) {
          clearInterval(window.queryTimer);
        }
      }
    },
    isStyleApplied: {
      handler(newVal, oldVal) {
        if (this.map) {
          if (this.cityLayer) {
            this.cityLayer.setStyle({
              color: this.isStyleApplied
                ? "rgba(214, 211, 241, 1)"
                : "rgba(255, 254, 190, 1)",
              weight: 2,
              fillColor: this.isStyleApplied
                ? "rgba(219, 217, 255, 0.48)"
                : "rgba(255, 246, 141, 0.48)",
              fillOpacity: 0.48
            });
          }
          this.airSpaces.map(v => {
            v.setStyle({
              color:
                this.allEyesModel ? 'rgba(214,211,241,0.48)' : v.spaceType === 0 || v.spaceType === 1
                  ? "#e21838"
                  : v.spaceType === 3
                    ? "#21f48e"
                    : v.spaceType === 4 ||
                      v.spaceType === 21
                      ? "yellow"
                      : v.spaceType === 11
                        ? "orange"
                        : null, //填充颜色, //边框颜色#aa0000
              fillColor:
                this.allEyesModel ? 'rgba(214,211,241,0.48)' : v.spaceType === 0 || v.spaceType === 1
                  ? "rgba(226,24,56,0.48)"
                  : v.spaceType === 3
                    ? "rgba(32,180,67,0.48)"
                    : v.spaceType === 4 ||
                      v.spaceType === 21
                      ? "rgba(252,255,44,0.48)"
                      : v.spaceType === 11
                        ? "rgba(248,168,34,0.48)"
                        : null, //填充颜色
              fillOpacity: 1, //填充透明度
              weight: 1 //边框宽度
            });
          })
        }
      }
    },
    isEyeshield: {
      handler(newVal, oldVal) {
        if (this.map) {
          this.updateTheme()
          if (this.cityLayer) {
            this.cityLayer.setStyle({
              color: this.isEyeshield
                ? "rgba(214, 211, 241, 1)"
                : "rgba(255, 254, 190, 1)",
              weight: 2,
              fillColor: this.isEyeshield
                ? "rgba(219, 217, 255, 0.48)"
                : "rgba(255, 246, 141, 0.48)",
              fillOpacity: 0.48
            });
          }
          this.airSpaces.map(v => {
            v.setStyle({
              color:
                this.allEyesModel ? 'rgba(214,211,241,0.48)' : v.spaceType === 0 || v.spaceType === 1
                  ? "#e21838"
                  : v.spaceType === 3
                    ? "#21f48e"
                    : v.spaceType === 4 ||
                      v.spaceType === 21
                      ? "yellow"
                      : v.spaceType === 11
                        ? "orange"
                        : null, //填充颜色, //边框颜色#aa0000
              fillColor:
                this.allEyesModel ? 'rgba(214,211,241,0.48)' : v.spaceType === 0 || v.spaceType === 1
                  ? "rgba(226,24,56,0.48)"
                  : v.spaceType === 3
                    ? "rgba(32,180,67,0.48)"
                    : v.spaceType === 4 ||
                      v.spaceType === 21
                      ? "rgba(252,255,44,0.48)"
                      : v.spaceType === 11
                        ? "rgba(248,168,34,0.48)"
                        : null, //填充颜色
              fillOpacity: 1, //填充透明度
              weight: 1 //边框宽度
            });
          })
        }
      }
    }
  }
};
</script>
<style scoped>
@import "../../assets/css/home/TaskControl.scss";
</style>



// WEBPACK FOOTER //
// src/components/home/TaskControl.vue